import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
export class ShipUpgradeDefinitions {
  get descriptor() {
    return ShipUpgradeDefinitions.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._shipTalentDefinitions = [];
    this._shipGoldTierSettings = [];
    this._shipSilverTierSettings = [];
  }
  isEmpty() {
    if (this._shipTalentDefinitions.length > 0) return false;
    if (this._shipGoldTierSettings.length > 0) return false;
    if (this._shipSilverTierSettings.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ShipUpgradeDefinitions) {
      return value;
    }
    return ShipUpgradeDefinitions.fromJson(value);
  }
  static fromJson(json) {
    const result = new ShipUpgradeDefinitions();
    result._shipTalentDefinitions = JsonToList(json.shipTalentDefinitions, ShipTalentDefinition);
    result._shipGoldTierSettings = JsonToList(json.shipGoldTierSettings, ShipTierSetting);
    result._shipSilverTierSettings = JsonToList(json.shipSilverTierSettings, ShipTierSetting);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._shipTalentDefinitions.length > 0) {
      result.shipTalentDefinitions = ArrayToJson(this._shipTalentDefinitions, ShipTalentDefinition);
    }
    if (this._shipGoldTierSettings.length > 0) {
      result.shipGoldTierSettings = ArrayToJson(this._shipGoldTierSettings, ShipTierSetting);
    }
    if (this._shipSilverTierSettings.length > 0) {
      result.shipSilverTierSettings = ArrayToJson(this._shipSilverTierSettings, ShipTierSetting);
    }
    return result;
  }
  /**
   * @returns {ShipTalentDefinition[]}
   */
  get shipTalentDefinitions() {
    return this._shipTalentDefinitions;
  }
  addShipTalentDefinitions(path, value) {
    return {type: 'ADD', path: path.concat(['shipTalentDefinitions']), value: value.toJson()};
  }
  setShipTalentDefinitions(path, value) {
    return {type: 'SET', path: path.concat(['shipTalentDefinitions']), value: ArrayToJson(value, ShipTalentDefinition)};
  }
  setShipTalentDefinitionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['shipTalentDefinitions', key]), value: value.toJson()};
  }
  deleteShipTalentDefinitions(path) {
    return {type: 'DELETE', path: path.concat(['shipTalentDefinitions'])};
  }
  deleteShipTalentDefinitionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['shipTalentDefinitions', key])};
  }
  /**
   * @returns {ShipTierSetting[]}
   */
  get shipGoldTierSettings() {
    return this._shipGoldTierSettings;
  }
  addShipGoldTierSettings(path, value) {
    return {type: 'ADD', path: path.concat(['shipGoldTierSettings']), value: value.toJson()};
  }
  setShipGoldTierSettings(path, value) {
    return {type: 'SET', path: path.concat(['shipGoldTierSettings']), value: ArrayToJson(value, ShipTierSetting)};
  }
  setShipGoldTierSettingsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['shipGoldTierSettings', key]), value: value.toJson()};
  }
  deleteShipGoldTierSettings(path) {
    return {type: 'DELETE', path: path.concat(['shipGoldTierSettings'])};
  }
  deleteShipGoldTierSettingsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['shipGoldTierSettings', key])};
  }
  /**
   * @returns {ShipTierSetting[]}
   */
  get shipSilverTierSettings() {
    return this._shipSilverTierSettings;
  }
  addShipSilverTierSettings(path, value) {
    return {type: 'ADD', path: path.concat(['shipSilverTierSettings']), value: value.toJson()};
  }
  setShipSilverTierSettings(path, value) {
    return {type: 'SET', path: path.concat(['shipSilverTierSettings']), value: ArrayToJson(value, ShipTierSetting)};
  }
  setShipSilverTierSettingsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['shipSilverTierSettings', key]), value: value.toJson()};
  }
  deleteShipSilverTierSettings(path) {
    return {type: 'DELETE', path: path.concat(['shipSilverTierSettings'])};
  }
  deleteShipSilverTierSettingsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['shipSilverTierSettings', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "shipTalentDefinitions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipUpgradeDefinitions(this);
              copy._shipTalentDefinitions = [];        for (let i of value) {
                copy._shipTalentDefinitions.push(ShipTalentDefinition.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ShipUpgradeDefinitions(this);
              copy._shipTalentDefinitions = copy._shipTalentDefinitions.concat([ShipTalentDefinition.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._shipTalentDefinitions.length === 0) {
                return this;
              }
              const copy = new ShipUpgradeDefinitions(this);
              copy._shipTalentDefinitions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._shipTalentDefinitions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ShipUpgradeDefinitions(this);
              copy._shipTalentDefinitions = copy._shipTalentDefinitions.slice();
              copy._shipTalentDefinitions[path[1]] = ShipTalentDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ShipUpgradeDefinitions(this);
              copy._shipTalentDefinitions = copy._shipTalentDefinitions.slice(0, path[1]).concat(copy._shipTalentDefinitions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._shipTalentDefinitions.length) {
            return this;
          }
          const oldValue = this._shipTalentDefinitions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ShipUpgradeDefinitions(this);
          copy._shipTalentDefinitions = copy._shipTalentDefinitions.slice();
          copy._shipTalentDefinitions[key] = newValue;
          return copy;
        }
      }
      case "shipGoldTierSettings": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipUpgradeDefinitions(this);
              copy._shipGoldTierSettings = [];        for (let i of value) {
                copy._shipGoldTierSettings.push(ShipTierSetting.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ShipUpgradeDefinitions(this);
              copy._shipGoldTierSettings = copy._shipGoldTierSettings.concat([ShipTierSetting.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._shipGoldTierSettings.length === 0) {
                return this;
              }
              const copy = new ShipUpgradeDefinitions(this);
              copy._shipGoldTierSettings = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._shipGoldTierSettings.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ShipUpgradeDefinitions(this);
              copy._shipGoldTierSettings = copy._shipGoldTierSettings.slice();
              copy._shipGoldTierSettings[path[1]] = ShipTierSetting.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ShipUpgradeDefinitions(this);
              copy._shipGoldTierSettings = copy._shipGoldTierSettings.slice(0, path[1]).concat(copy._shipGoldTierSettings.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._shipGoldTierSettings.length) {
            return this;
          }
          const oldValue = this._shipGoldTierSettings[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ShipUpgradeDefinitions(this);
          copy._shipGoldTierSettings = copy._shipGoldTierSettings.slice();
          copy._shipGoldTierSettings[key] = newValue;
          return copy;
        }
      }
      case "shipSilverTierSettings": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipUpgradeDefinitions(this);
              copy._shipSilverTierSettings = [];        for (let i of value) {
                copy._shipSilverTierSettings.push(ShipTierSetting.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ShipUpgradeDefinitions(this);
              copy._shipSilverTierSettings = copy._shipSilverTierSettings.concat([ShipTierSetting.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._shipSilverTierSettings.length === 0) {
                return this;
              }
              const copy = new ShipUpgradeDefinitions(this);
              copy._shipSilverTierSettings = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._shipSilverTierSettings.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ShipUpgradeDefinitions(this);
              copy._shipSilverTierSettings = copy._shipSilverTierSettings.slice();
              copy._shipSilverTierSettings[path[1]] = ShipTierSetting.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ShipUpgradeDefinitions(this);
              copy._shipSilverTierSettings = copy._shipSilverTierSettings.slice(0, path[1]).concat(copy._shipSilverTierSettings.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._shipSilverTierSettings.length) {
            return this;
          }
          const oldValue = this._shipSilverTierSettings[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ShipUpgradeDefinitions(this);
          copy._shipSilverTierSettings = copy._shipSilverTierSettings.slice();
          copy._shipSilverTierSettings[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ShipUpgradeDefinitions} other
   * @returns {ShipUpgradeDefinitions}
   */
  merge(other) {
    const copy = new ShipUpgradeDefinitions(this);
    copy._shipTalentDefinitions = this._shipTalentDefinitions.concat(other._shipTalentDefinitions);
    copy._shipGoldTierSettings = this._shipGoldTierSettings.concat(other._shipGoldTierSettings);
    copy._shipSilverTierSettings = this._shipSilverTierSettings.concat(other._shipSilverTierSettings);
    return copy;
  }
}
ShipUpgradeDefinitions.default = new ShipUpgradeDefinitions();
class ShipUpgradeDefinitions_Builder {
  constructor(value) {
    this._value = new ShipUpgradeDefinitions(value);
  }
  build() {
    return new ShipUpgradeDefinitions(this._value);
  }
  addAllShipTalentDefinitions(values) {
    this._value._shipTalentDefinitions = this._value._shipTalentDefinitions.concat(values);
    return this;
  }
  addShipTalentDefinitions(value) {
    this._value._shipTalentDefinitions = this._value._shipTalentDefinitions.concat([value]);
    return this;
  }
  setShipTalentDefinitions(index, value) {
    this._value._shipTalentDefinitions = this._value._shipTalentDefinitions.concat();
    this._value._shipTalentDefinitions[index] = value;
    return this;
  }
  clearShipTalentDefinitions() {
    this._value._shipTalentDefinitions = [];
    return this;
  }
  addAllShipGoldTierSettings(values) {
    this._value._shipGoldTierSettings = this._value._shipGoldTierSettings.concat(values);
    return this;
  }
  addShipGoldTierSettings(value) {
    this._value._shipGoldTierSettings = this._value._shipGoldTierSettings.concat([value]);
    return this;
  }
  setShipGoldTierSettings(index, value) {
    this._value._shipGoldTierSettings = this._value._shipGoldTierSettings.concat();
    this._value._shipGoldTierSettings[index] = value;
    return this;
  }
  clearShipGoldTierSettings() {
    this._value._shipGoldTierSettings = [];
    return this;
  }
  addAllShipSilverTierSettings(values) {
    this._value._shipSilverTierSettings = this._value._shipSilverTierSettings.concat(values);
    return this;
  }
  addShipSilverTierSettings(value) {
    this._value._shipSilverTierSettings = this._value._shipSilverTierSettings.concat([value]);
    return this;
  }
  setShipSilverTierSettings(index, value) {
    this._value._shipSilverTierSettings = this._value._shipSilverTierSettings.concat();
    this._value._shipSilverTierSettings[index] = value;
    return this;
  }
  clearShipSilverTierSettings() {
    this._value._shipSilverTierSettings = [];
    return this;
  }
}
ShipUpgradeDefinitions.Builder = ShipUpgradeDefinitions_Builder;
class ShipUpgradeDefinitions_WithParent {
  /**
   * @param {ShipUpgradeDefinitions} value
   * @param {ShipUpgradeDefinitions_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ShipUpgradeDefinitions.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfShipTalentDefinitions() {
    if (!this._selfShipTalentDefinitions) {
      this._selfShipTalentDefinitions = [];
      for (let i of this._value.shipTalentDefinitions) {
        this._selfShipTalentDefinitions.push(new ShipTalentDefinition.WithParent(i, null));
      }
    }
    return this._selfShipTalentDefinitions;
  }
  get inherentShipTalentDefinitions() {
    if (!this._inherentShipTalentDefinitions) {
      this._inherentShipTalentDefinitions = this._parent ? this._parent.shipTalentDefinitions : [];
    }
    return this._inherentShipTalentDefinitions;
  }
  get shipTalentDefinitions() {
    if (!this._allShipTalentDefinitions) {
      this._allShipTalentDefinitions = this._parent ? this._parent.shipTalentDefinitions.concat(this.selfShipTalentDefinitions) : this.selfShipTalentDefinitions;
    }
    return this._allShipTalentDefinitions;
  }
  get selfShipGoldTierSettings() {
    if (!this._selfShipGoldTierSettings) {
      this._selfShipGoldTierSettings = [];
      for (let i of this._value.shipGoldTierSettings) {
        this._selfShipGoldTierSettings.push(new ShipTierSetting.WithParent(i, null));
      }
    }
    return this._selfShipGoldTierSettings;
  }
  get inherentShipGoldTierSettings() {
    if (!this._inherentShipGoldTierSettings) {
      this._inherentShipGoldTierSettings = this._parent ? this._parent.shipGoldTierSettings : [];
    }
    return this._inherentShipGoldTierSettings;
  }
  get shipGoldTierSettings() {
    if (!this._allShipGoldTierSettings) {
      this._allShipGoldTierSettings = this._parent ? this._parent.shipGoldTierSettings.concat(this.selfShipGoldTierSettings) : this.selfShipGoldTierSettings;
    }
    return this._allShipGoldTierSettings;
  }
  get selfShipSilverTierSettings() {
    if (!this._selfShipSilverTierSettings) {
      this._selfShipSilverTierSettings = [];
      for (let i of this._value.shipSilverTierSettings) {
        this._selfShipSilverTierSettings.push(new ShipTierSetting.WithParent(i, null));
      }
    }
    return this._selfShipSilverTierSettings;
  }
  get inherentShipSilverTierSettings() {
    if (!this._inherentShipSilverTierSettings) {
      this._inherentShipSilverTierSettings = this._parent ? this._parent.shipSilverTierSettings : [];
    }
    return this._inherentShipSilverTierSettings;
  }
  get shipSilverTierSettings() {
    if (!this._allShipSilverTierSettings) {
      this._allShipSilverTierSettings = this._parent ? this._parent.shipSilverTierSettings.concat(this.selfShipSilverTierSettings) : this.selfShipSilverTierSettings;
    }
    return this._allShipSilverTierSettings;
  }
  update(current, parent) {
    const result = new ShipUpgradeDefinitions_WithParent(current, parent);
    if (this._selfShipTalentDefinitions) {
      if (this._value.shipTalentDefinitions === current.shipTalentDefinitions) {
        result._selfShipTalentDefinitions = this._selfShipTalentDefinitions;
      } else {
        result._selfShipTalentDefinitions = [];
        for (let i = 0; i < current.shipTalentDefinitions.length; i++) {
          const oldValue = this._value.shipTalentDefinitions[i];
          if (oldValue) {
            const oldCache = this._selfShipTalentDefinitions[i];
            if (oldValue === current.shipTalentDefinitions[i]) {
              result._selfShipTalentDefinitions[i] = oldCache;
            } else {
              result._selfShipTalentDefinitions[i] = oldCache.update(current.shipTalentDefinitions[i], null);
            }
          } else {
            result._selfShipTalentDefinitions[i] = new ShipTalentDefinition.WithParent(current.shipTalentDefinitions[i], null);
          }
        }
      }
    }
    if (this._selfShipGoldTierSettings) {
      if (this._value.shipGoldTierSettings === current.shipGoldTierSettings) {
        result._selfShipGoldTierSettings = this._selfShipGoldTierSettings;
      } else {
        result._selfShipGoldTierSettings = [];
        for (let i = 0; i < current.shipGoldTierSettings.length; i++) {
          const oldValue = this._value.shipGoldTierSettings[i];
          if (oldValue) {
            const oldCache = this._selfShipGoldTierSettings[i];
            if (oldValue === current.shipGoldTierSettings[i]) {
              result._selfShipGoldTierSettings[i] = oldCache;
            } else {
              result._selfShipGoldTierSettings[i] = oldCache.update(current.shipGoldTierSettings[i], null);
            }
          } else {
            result._selfShipGoldTierSettings[i] = new ShipTierSetting.WithParent(current.shipGoldTierSettings[i], null);
          }
        }
      }
    }
    if (this._selfShipSilverTierSettings) {
      if (this._value.shipSilverTierSettings === current.shipSilverTierSettings) {
        result._selfShipSilverTierSettings = this._selfShipSilverTierSettings;
      } else {
        result._selfShipSilverTierSettings = [];
        for (let i = 0; i < current.shipSilverTierSettings.length; i++) {
          const oldValue = this._value.shipSilverTierSettings[i];
          if (oldValue) {
            const oldCache = this._selfShipSilverTierSettings[i];
            if (oldValue === current.shipSilverTierSettings[i]) {
              result._selfShipSilverTierSettings[i] = oldCache;
            } else {
              result._selfShipSilverTierSettings[i] = oldCache.update(current.shipSilverTierSettings[i], null);
            }
          } else {
            result._selfShipSilverTierSettings[i] = new ShipTierSetting.WithParent(current.shipSilverTierSettings[i], null);
          }
        }
      }
    }
    return result;
  }
}
ShipUpgradeDefinitions_WithParent.default = new ShipUpgradeDefinitions_WithParent(ShipUpgradeDefinitions.default, null);
ShipUpgradeDefinitions.WithParent = ShipUpgradeDefinitions_WithParent;
class ShipUpgradeDefinitions_Descriptor {
  get shipTalentDefinitions() {
    if (!this._shipTalentDefinitions) {
      this._shipTalentDefinitions = {
        name: "shipTalentDefinitions",
        Name: "ShipTalentDefinitions",
        number: 1,
        protoType: 11,
        protoName: "ship_talent_definitions",
        type: ShipTalentDefinition,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._shipTalentDefinitions;
  }
  get shipGoldTierSettings() {
    if (!this._shipGoldTierSettings) {
      this._shipGoldTierSettings = {
        name: "shipGoldTierSettings",
        Name: "ShipGoldTierSettings",
        number: 2,
        protoType: 11,
        protoName: "ship_gold_tier_settings",
        type: ShipTierSetting,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._shipGoldTierSettings;
  }
  get shipSilverTierSettings() {
    if (!this._shipSilverTierSettings) {
      this._shipSilverTierSettings = {
        name: "shipSilverTierSettings",
        Name: "ShipSilverTierSettings",
        number: 3,
        protoType: 11,
        protoName: "ship_silver_tier_settings",
        type: ShipTierSetting,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._shipSilverTierSettings;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.shipTalentDefinitions,
        this.shipGoldTierSettings,
        this.shipSilverTierSettings,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
ShipUpgradeDefinitions.descriptor = new ShipUpgradeDefinitions_Descriptor();
export class ShipTierSetting {
  get descriptor() {
    return ShipTierSetting.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTier = false;
    this._tier = null;
    this._talentNames = [];
    this._hasGoldStarRequirement = false;
    this._goldStarRequirement = null;
    this._hasSilverStarRequirement = false;
    this._silverStarRequirement = null;
  }
  isEmpty() {
    if (this._hasTier) return false;
    if (this._talentNames.length > 0) return false;
    if (this._hasGoldStarRequirement) return false;
    if (this._hasSilverStarRequirement) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ShipTierSetting) {
      return value;
    }
    return ShipTierSetting.fromJson(value);
  }
  static fromJson(json) {
    const result = new ShipTierSetting();
    if (json.tier != null) {
      result._hasTier = true;
      result._tier = JsonToInt32.fromJson(json.tier);
    }
    result._talentNames = JsonToList(json.talentNames, JsonToString);
    if (json.goldStarRequirement != null) {
      result._hasGoldStarRequirement = true;
      result._goldStarRequirement = JsonToInt32.fromJson(json.goldStarRequirement);
    }
    if (json.silverStarRequirement != null) {
      result._hasSilverStarRequirement = true;
      result._silverStarRequirement = JsonToInt32.fromJson(json.silverStarRequirement);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTier) {
      result.tier = JsonToInt32.toJson(this._tier);
    }
    if (this._talentNames.length > 0) {
      result.talentNames = ArrayToJson(this._talentNames, JsonToString);
    }
    if (this._hasGoldStarRequirement) {
      result.goldStarRequirement = JsonToInt32.toJson(this._goldStarRequirement);
    }
    if (this._hasSilverStarRequirement) {
      result.silverStarRequirement = JsonToInt32.toJson(this._silverStarRequirement);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get tier() {
    return this._hasTier ? this._tier : JsonToInt32.default;
  }
  get hasTier() {
    return this._hasTier;
  }
  setTier(path, value) {
    return {type: 'SET', path: path.concat(['tier']), value};
  }
  deleteTier(path) {
    return {type: 'DELETE', path: path.concat(['tier'])};
  }
  /**
   * @returns {string[]}
   */
  get talentNames() {
    return this._talentNames;
  }
  addTalentNames(path, value) {
    return {type: 'ADD', path: path.concat(['talentNames']), value};
  }
  setTalentNames(path, value) {
    return {type: 'SET', path: path.concat(['talentNames']), value: ArrayToJson(value, JsonToString)};
  }
  setTalentNamesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['talentNames', key]), value};
  }
  deleteTalentNames(path) {
    return {type: 'DELETE', path: path.concat(['talentNames'])};
  }
  deleteTalentNamesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['talentNames', key])};
  }
  /**
   * @returns {number}
   */
  get goldStarRequirement() {
    return this._hasGoldStarRequirement ? this._goldStarRequirement : JsonToInt32.default;
  }
  get hasGoldStarRequirement() {
    return this._hasGoldStarRequirement;
  }
  setGoldStarRequirement(path, value) {
    return {type: 'SET', path: path.concat(['goldStarRequirement']), value};
  }
  deleteGoldStarRequirement(path) {
    return {type: 'DELETE', path: path.concat(['goldStarRequirement'])};
  }
  /**
   * @returns {number}
   */
  get silverStarRequirement() {
    return this._hasSilverStarRequirement ? this._silverStarRequirement : JsonToInt32.default;
  }
  get hasSilverStarRequirement() {
    return this._hasSilverStarRequirement;
  }
  setSilverStarRequirement(path, value) {
    return {type: 'SET', path: path.concat(['silverStarRequirement']), value};
  }
  deleteSilverStarRequirement(path) {
    return {type: 'DELETE', path: path.concat(['silverStarRequirement'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "tier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipTierSetting(this);
              copy._hasTier = true;
              copy._tier = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTier) {
                return this;
              }
              const copy = new ShipTierSetting(this);
              copy._hasTier = false;
              copy._tier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "talentNames": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipTierSetting(this);
              copy._talentNames = [];        for (let i of value) {
                copy._talentNames.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ShipTierSetting(this);
              copy._talentNames = copy._talentNames.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._talentNames.length === 0) {
                return this;
              }
              const copy = new ShipTierSetting(this);
              copy._talentNames = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._talentNames.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ShipTierSetting(this);
              copy._talentNames = copy._talentNames.slice();
              copy._talentNames[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ShipTierSetting(this);
              copy._talentNames = copy._talentNames.slice(0, path[1]).concat(copy._talentNames.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._talentNames.length) {
            return this;
          }
          const oldValue = this._talentNames[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ShipTierSetting(this);
          copy._talentNames = copy._talentNames.slice();
          copy._talentNames[key] = newValue;
          return copy;
        }
      }
      case "goldStarRequirement": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipTierSetting(this);
              copy._hasGoldStarRequirement = true;
              copy._goldStarRequirement = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGoldStarRequirement) {
                return this;
              }
              const copy = new ShipTierSetting(this);
              copy._hasGoldStarRequirement = false;
              copy._goldStarRequirement = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "silverStarRequirement": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipTierSetting(this);
              copy._hasSilverStarRequirement = true;
              copy._silverStarRequirement = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSilverStarRequirement) {
                return this;
              }
              const copy = new ShipTierSetting(this);
              copy._hasSilverStarRequirement = false;
              copy._silverStarRequirement = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ShipTierSetting} other
   * @returns {ShipTierSetting}
   */
  merge(other) {
    const copy = new ShipTierSetting(this);
    if (other._hasTier) {
      copy._hasTier = true;
      copy._tier = other._tier;
    }
    copy._talentNames = this._talentNames.concat(other._talentNames);
    if (other._hasGoldStarRequirement) {
      copy._hasGoldStarRequirement = true;
      copy._goldStarRequirement = other._goldStarRequirement;
    }
    if (other._hasSilverStarRequirement) {
      copy._hasSilverStarRequirement = true;
      copy._silverStarRequirement = other._silverStarRequirement;
    }
    return copy;
  }
}
ShipTierSetting.default = new ShipTierSetting();
class ShipTierSetting_Builder {
  constructor(value) {
    this._value = new ShipTierSetting(value);
  }
  build() {
    return new ShipTierSetting(this._value);
  }
  setTier(value) {
    this._value._hasTier = true;
    this._value._tier = value;
    return this;
  }
  deleteTier() {
    this._value._hasTier = false;
    this._value._tier = null;
    return this;
  }
  addAllTalentNames(values) {
    this._value._talentNames = this._value._talentNames.concat(values);
    return this;
  }
  addTalentNames(value) {
    this._value._talentNames = this._value._talentNames.concat([value]);
    return this;
  }
  setTalentNames(index, value) {
    this._value._talentNames = this._value._talentNames.concat();
    this._value._talentNames[index] = value;
    return this;
  }
  clearTalentNames() {
    this._value._talentNames = [];
    return this;
  }
  setGoldStarRequirement(value) {
    this._value._hasGoldStarRequirement = true;
    this._value._goldStarRequirement = value;
    return this;
  }
  deleteGoldStarRequirement() {
    this._value._hasGoldStarRequirement = false;
    this._value._goldStarRequirement = null;
    return this;
  }
  setSilverStarRequirement(value) {
    this._value._hasSilverStarRequirement = true;
    this._value._silverStarRequirement = value;
    return this;
  }
  deleteSilverStarRequirement() {
    this._value._hasSilverStarRequirement = false;
    this._value._silverStarRequirement = null;
    return this;
  }
}
ShipTierSetting.Builder = ShipTierSetting_Builder;
class ShipTierSetting_WithParent {
  /**
   * @param {ShipTierSetting} value
   * @param {ShipTierSetting_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ShipTierSetting.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTier() {
    if (this._cachedHasTier === undefined) {
      if (this._value.hasTier) {
        this._cachedHasTier = true;
      } else {
        this._cachedHasTier = this._parent ? this._parent.hasTier : false;
      }
    }
    return this._cachedHasTier;
  }
  get tier() {
    if (this._cachedTier === undefined) {
      if (this._value.hasTier) {
        this._cachedTier = this._value.tier;
      } else {
        this._cachedTier = this._parent ? this._parent.tier : this._value.tier;
      }
    }
    return this._cachedTier;
  }
  get selfTalentNames() {
    return this._value.talentNames;
  }
  get inherentTalentNames() {
    if (!this._inherentTalentNames) {
      this._inherentTalentNames = this._parent ? this._parent.talentNames : [];
    }
    return this._inherentTalentNames;
  }
  get talentNames() {
    if (!this._allTalentNames) {
      this._allTalentNames = this._parent ? this._parent.talentNames.concat(this.selfTalentNames) : this.selfTalentNames;
    }
    return this._allTalentNames;
  }
  get hasGoldStarRequirement() {
    if (this._cachedHasGoldStarRequirement === undefined) {
      if (this._value.hasGoldStarRequirement) {
        this._cachedHasGoldStarRequirement = true;
      } else {
        this._cachedHasGoldStarRequirement = this._parent ? this._parent.hasGoldStarRequirement : false;
      }
    }
    return this._cachedHasGoldStarRequirement;
  }
  get goldStarRequirement() {
    if (this._cachedGoldStarRequirement === undefined) {
      if (this._value.hasGoldStarRequirement) {
        this._cachedGoldStarRequirement = this._value.goldStarRequirement;
      } else {
        this._cachedGoldStarRequirement = this._parent ? this._parent.goldStarRequirement : this._value.goldStarRequirement;
      }
    }
    return this._cachedGoldStarRequirement;
  }
  get hasSilverStarRequirement() {
    if (this._cachedHasSilverStarRequirement === undefined) {
      if (this._value.hasSilverStarRequirement) {
        this._cachedHasSilverStarRequirement = true;
      } else {
        this._cachedHasSilverStarRequirement = this._parent ? this._parent.hasSilverStarRequirement : false;
      }
    }
    return this._cachedHasSilverStarRequirement;
  }
  get silverStarRequirement() {
    if (this._cachedSilverStarRequirement === undefined) {
      if (this._value.hasSilverStarRequirement) {
        this._cachedSilverStarRequirement = this._value.silverStarRequirement;
      } else {
        this._cachedSilverStarRequirement = this._parent ? this._parent.silverStarRequirement : this._value.silverStarRequirement;
      }
    }
    return this._cachedSilverStarRequirement;
  }
  update(current, parent) {
    const result = new ShipTierSetting_WithParent(current, parent);
    return result;
  }
}
ShipTierSetting_WithParent.default = new ShipTierSetting_WithParent(ShipTierSetting.default, null);
ShipTierSetting.WithParent = ShipTierSetting_WithParent;
class ShipTierSetting_Descriptor {
  get tier() {
    if (!this._tier) {
      this._tier = {
        name: "tier",
        Name: "Tier",
        number: 1,
        protoType: 5,
        protoName: "tier",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tier;
  }
  get talentNames() {
    if (!this._talentNames) {
      this._talentNames = {
        name: "talentNames",
        Name: "TalentNames",
        number: 2,
        protoType: 9,
        protoName: "talent_names",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._talentNames;
  }
  get goldStarRequirement() {
    if (!this._goldStarRequirement) {
      this._goldStarRequirement = {
        name: "goldStarRequirement",
        Name: "GoldStarRequirement",
        number: 3,
        protoType: 5,
        protoName: "gold_star_requirement",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._goldStarRequirement;
  }
  get silverStarRequirement() {
    if (!this._silverStarRequirement) {
      this._silverStarRequirement = {
        name: "silverStarRequirement",
        Name: "SilverStarRequirement",
        number: 4,
        protoType: 5,
        protoName: "silver_star_requirement",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._silverStarRequirement;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.tier,
        this.talentNames,
        this.goldStarRequirement,
        this.silverStarRequirement,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTier",
        Name: "DummyOneofForTier",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGoldStarRequirement",
        Name: "DummyOneofForGoldStarRequirement",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSilverStarRequirement",
        Name: "DummyOneofForSilverStarRequirement",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
ShipTierSetting.descriptor = new ShipTierSetting_Descriptor();
class CardBoost_CardTypeBoost {
  get descriptor() {
    return CardBoost_CardTypeBoost.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCardType = false;
    this._cardType = null;
    this._hasCardSlotBoost = false;
    this._cardSlotBoost = null;
  }
  isEmpty() {
    if (this._hasCardType) return false;
    if (this._hasCardSlotBoost) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardBoost_CardTypeBoost) {
      return value;
    }
    return CardBoost_CardTypeBoost.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardBoost_CardTypeBoost();
    if (json.cardType != null) {
      result._hasCardType = true;
      result._cardType = CardBoost_CardType.fromJson(json.cardType);
    }
    if (json.cardSlotBoost != null) {
      result._hasCardSlotBoost = true;
      result._cardSlotBoost = JsonToInt32.fromJson(json.cardSlotBoost);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCardType) {
      result.cardType = CardBoost_CardType.toJson(this._cardType);
    }
    if (this._hasCardSlotBoost) {
      result.cardSlotBoost = JsonToInt32.toJson(this._cardSlotBoost);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get cardType() {
    return this._hasCardType ? this._cardType : CardBoost_CardType.default;
  }
  get hasCardType() {
    return this._hasCardType;
  }
  setCardType(path, value) {
    return {type: 'SET', path: path.concat(['cardType']), value};
  }
  deleteCardType(path) {
    return {type: 'DELETE', path: path.concat(['cardType'])};
  }
  /**
   * @returns {number}
   */
  get cardSlotBoost() {
    return this._hasCardSlotBoost ? this._cardSlotBoost : JsonToInt32.default;
  }
  get hasCardSlotBoost() {
    return this._hasCardSlotBoost;
  }
  setCardSlotBoost(path, value) {
    return {type: 'SET', path: path.concat(['cardSlotBoost']), value};
  }
  deleteCardSlotBoost(path) {
    return {type: 'DELETE', path: path.concat(['cardSlotBoost'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "cardType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardBoost_CardTypeBoost(this);
              copy._hasCardType = true;
              copy._cardType = CardBoost_CardType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardType) {
                return this;
              }
              const copy = new CardBoost_CardTypeBoost(this);
              copy._hasCardType = false;
              copy._cardType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cardSlotBoost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardBoost_CardTypeBoost(this);
              copy._hasCardSlotBoost = true;
              copy._cardSlotBoost = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardSlotBoost) {
                return this;
              }
              const copy = new CardBoost_CardTypeBoost(this);
              copy._hasCardSlotBoost = false;
              copy._cardSlotBoost = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardBoost_CardTypeBoost} other
   * @returns {CardBoost_CardTypeBoost}
   */
  merge(other) {
    const copy = new CardBoost_CardTypeBoost(this);
    if (other._hasCardType) {
      copy._hasCardType = true;
      copy._cardType = other._cardType;
    }
    if (other._hasCardSlotBoost) {
      copy._hasCardSlotBoost = true;
      copy._cardSlotBoost = other._cardSlotBoost;
    }
    return copy;
  }
}
CardBoost_CardTypeBoost.default = new CardBoost_CardTypeBoost();
class CardBoost_CardTypeBoost_Builder {
  constructor(value) {
    this._value = new CardBoost_CardTypeBoost(value);
  }
  build() {
    return new CardBoost_CardTypeBoost(this._value);
  }
  setCardType(value) {
    this._value._hasCardType = true;
    this._value._cardType = value;
    return this;
  }
  deleteCardType() {
    this._value._hasCardType = false;
    this._value._cardType = null;
    return this;
  }
  setCardSlotBoost(value) {
    this._value._hasCardSlotBoost = true;
    this._value._cardSlotBoost = value;
    return this;
  }
  deleteCardSlotBoost() {
    this._value._hasCardSlotBoost = false;
    this._value._cardSlotBoost = null;
    return this;
  }
}
CardBoost_CardTypeBoost.Builder = CardBoost_CardTypeBoost_Builder;
class CardBoost_CardTypeBoost_WithParent {
  /**
   * @param {CardBoost_CardTypeBoost} value
   * @param {CardBoost_CardTypeBoost_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardBoost_CardTypeBoost.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCardType() {
    if (this._cachedHasCardType === undefined) {
      if (this._value.hasCardType) {
        this._cachedHasCardType = true;
      } else {
        this._cachedHasCardType = this._parent ? this._parent.hasCardType : false;
      }
    }
    return this._cachedHasCardType;
  }
  get cardType() {
    if (this._cachedCardType === undefined) {
      if (this._value.hasCardType) {
        this._cachedCardType = this._value.cardType;
      } else {
        this._cachedCardType = this._parent ? this._parent.cardType : this._value.cardType;
      }
    }
    return this._cachedCardType;
  }
  get hasCardSlotBoost() {
    if (this._cachedHasCardSlotBoost === undefined) {
      if (this._value.hasCardSlotBoost) {
        this._cachedHasCardSlotBoost = true;
      } else {
        this._cachedHasCardSlotBoost = this._parent ? this._parent.hasCardSlotBoost : false;
      }
    }
    return this._cachedHasCardSlotBoost;
  }
  get cardSlotBoost() {
    if (this._cachedCardSlotBoost === undefined) {
      if (this._value.hasCardSlotBoost) {
        this._cachedCardSlotBoost = this._value.cardSlotBoost;
      } else {
        this._cachedCardSlotBoost = this._parent ? this._parent.cardSlotBoost : this._value.cardSlotBoost;
      }
    }
    return this._cachedCardSlotBoost;
  }
  update(current, parent) {
    const result = new CardBoost_CardTypeBoost_WithParent(current, parent);
    return result;
  }
}
CardBoost_CardTypeBoost_WithParent.default = new CardBoost_CardTypeBoost_WithParent(CardBoost_CardTypeBoost.default, null);
CardBoost_CardTypeBoost.WithParent = CardBoost_CardTypeBoost_WithParent;
class CardBoost_CardTypeBoost_Descriptor {
  get cardType() {
    if (!this._cardType) {
      this._cardType = {
        name: "cardType",
        Name: "CardType",
        number: 1,
        protoType: 14,
        protoName: "card_type",
        type: CardBoost_CardType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardType;
  }
  get cardSlotBoost() {
    if (!this._cardSlotBoost) {
      this._cardSlotBoost = {
        name: "cardSlotBoost",
        Name: "CardSlotBoost",
        number: 2,
        protoType: 5,
        protoName: "card_slot_boost",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardSlotBoost;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.cardType,
        this.cardSlotBoost,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCardType",
        Name: "DummyOneofForCardType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCardSlotBoost",
        Name: "DummyOneofForCardSlotBoost",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
CardBoost_CardTypeBoost.descriptor = new CardBoost_CardTypeBoost_Descriptor();
class CardBoost_CardType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "All": return 0;
        case "Hero": return 1;
        case "Tower": return 2;
        case "Spell": return 3;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return CardBoost_CardType.fromJson(value);
  }
  static fromReact(e) {
    return CardBoost_CardType.fromJson(e);
  }
}
CardBoost_CardType.All = 0;
CardBoost_CardType.Hero = 1;
CardBoost_CardType.Tower = 2;
CardBoost_CardType.Spell = 3;
CardBoost_CardType.default = 0;
CardBoost_CardType.values = {
  All: 0,
  Hero: 1,
  Tower: 2,
  Spell: 3,
};
CardBoost_CardType.names = {
  0: "All",
  1: "Hero",
  2: "Tower",
  3: "Spell",
};
export class CardBoost {
  get descriptor() {
    return CardBoost.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._boostTypeCase = 0;
    this._boostTypeValue = null;
    this._hasCardLevelBoost = false;
    this._cardLevelBoost = null;
    this._hasCardSkillLevelBoost = false;
    this._cardSkillLevelBoost = null;
    this._hasCardAwakenBoost = false;
    this._cardAwakenBoost = null;
  }
  isEmpty() {
    if (this._boostTypeCase !== 0) return false;
    if (this._hasCardLevelBoost) return false;
    if (this._hasCardSkillLevelBoost) return false;
    if (this._hasCardAwakenBoost) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardBoost) {
      return value;
    }
    return CardBoost.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardBoost();
    if (json.cardName != null) {
      result._boostTypeCase = 1;
      result._boostTypeValue = JsonToString.fromJson(json.cardName);
    }
    if (json.cardType != null) {
      result._boostTypeCase = 2;
      result._boostTypeValue = CardBoost_CardTypeBoost.fromJson(json.cardType);
    }
    if (json.cardLevelBoost != null) {
      result._hasCardLevelBoost = true;
      result._cardLevelBoost = JsonToInt32.fromJson(json.cardLevelBoost);
    }
    if (json.cardSkillLevelBoost != null) {
      result._hasCardSkillLevelBoost = true;
      result._cardSkillLevelBoost = JsonToInt32.fromJson(json.cardSkillLevelBoost);
    }
    if (json.cardAwakenBoost != null) {
      result._hasCardAwakenBoost = true;
      result._cardAwakenBoost = JsonToInt32.fromJson(json.cardAwakenBoost);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._boostTypeCase) {
      case 1:
        result.cardName = JsonToString.toJson(this._boostTypeValue);
        break;
      case 2:
        result.cardType = CardBoost_CardTypeBoost.toJson(this._boostTypeValue);
        break;
      default:
        break;
    }
    if (this._hasCardLevelBoost) {
      result.cardLevelBoost = JsonToInt32.toJson(this._cardLevelBoost);
    }
    if (this._hasCardSkillLevelBoost) {
      result.cardSkillLevelBoost = JsonToInt32.toJson(this._cardSkillLevelBoost);
    }
    if (this._hasCardAwakenBoost) {
      result.cardAwakenBoost = JsonToInt32.toJson(this._cardAwakenBoost);
    }
    return result;
  }
  get boostTypeCase() {
    return this._boostTypeCase;
  }
  deleteBoostType(path) {
    switch (this._boostTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['cardName'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['cardType'])};
      }
    }
  }
  /**
   * @returns {string}
   */
  get cardName() {
    return this._boostTypeCase === 1 ? this._boostTypeValue : JsonToString.default;
  }
  setCardName(path, value) {
    return {type: 'SET', path: path.concat(['cardName']), value};
  }
  deleteCardName(path) {
    return {type: 'DELETE', path: path.concat(['cardName'])};
  }
  /**
   * @returns {CardBoost_CardTypeBoost}
   */
  get cardType() {
    return this._boostTypeCase === 2 ? this._boostTypeValue : CardBoost_CardTypeBoost.default;
  }
  setCardType(path, value) {
    return {type: 'SET', path: path.concat(['cardType']), value: value.toJson()};
  }
  deleteCardType(path) {
    return {type: 'DELETE', path: path.concat(['cardType'])};
  }
  /**
   * @returns {number}
   */
  get cardLevelBoost() {
    return this._hasCardLevelBoost ? this._cardLevelBoost : JsonToInt32.default;
  }
  get hasCardLevelBoost() {
    return this._hasCardLevelBoost;
  }
  setCardLevelBoost(path, value) {
    return {type: 'SET', path: path.concat(['cardLevelBoost']), value};
  }
  deleteCardLevelBoost(path) {
    return {type: 'DELETE', path: path.concat(['cardLevelBoost'])};
  }
  /**
   * @returns {number}
   */
  get cardSkillLevelBoost() {
    return this._hasCardSkillLevelBoost ? this._cardSkillLevelBoost : JsonToInt32.default;
  }
  get hasCardSkillLevelBoost() {
    return this._hasCardSkillLevelBoost;
  }
  setCardSkillLevelBoost(path, value) {
    return {type: 'SET', path: path.concat(['cardSkillLevelBoost']), value};
  }
  deleteCardSkillLevelBoost(path) {
    return {type: 'DELETE', path: path.concat(['cardSkillLevelBoost'])};
  }
  /**
   * @returns {number}
   */
  get cardAwakenBoost() {
    return this._hasCardAwakenBoost ? this._cardAwakenBoost : JsonToInt32.default;
  }
  get hasCardAwakenBoost() {
    return this._hasCardAwakenBoost;
  }
  setCardAwakenBoost(path, value) {
    return {type: 'SET', path: path.concat(['cardAwakenBoost']), value};
  }
  deleteCardAwakenBoost(path) {
    return {type: 'DELETE', path: path.concat(['cardAwakenBoost'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "cardName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardBoost(this);
              copy._boostTypeCase = 1;
              copy._boostTypeValue = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._boostTypeCase !== 1) {
                return this;
              }
              const copy = new CardBoost(this);
              copy._boostTypeCase = 0;
              copy._boostTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cardType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardBoost(this);
              copy._boostTypeCase = 2;
              copy._boostTypeValue = CardBoost_CardTypeBoost.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._boostTypeCase !== 2) {
                return this;
              }
              const copy = new CardBoost(this);
              copy._boostTypeCase = 0;
              copy._boostTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._boostTypeCase !== 2) {
            const copy = new CardBoost(this);
            copy._boostTypeCase = 2;
            copy._boostTypeValue = CardBoost_CardTypeBoost.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.cardType.apply(type, path.slice(1), value);
          if (newValue === this.cardType) {
            return this;
          }
          const copy = new CardBoost(this);
          copy._boostTypeCase = 2;
          copy._boostTypeValue = newValue;
          return copy;
        }
      }
      case "cardLevelBoost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardBoost(this);
              copy._hasCardLevelBoost = true;
              copy._cardLevelBoost = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardLevelBoost) {
                return this;
              }
              const copy = new CardBoost(this);
              copy._hasCardLevelBoost = false;
              copy._cardLevelBoost = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cardSkillLevelBoost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardBoost(this);
              copy._hasCardSkillLevelBoost = true;
              copy._cardSkillLevelBoost = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardSkillLevelBoost) {
                return this;
              }
              const copy = new CardBoost(this);
              copy._hasCardSkillLevelBoost = false;
              copy._cardSkillLevelBoost = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cardAwakenBoost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardBoost(this);
              copy._hasCardAwakenBoost = true;
              copy._cardAwakenBoost = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardAwakenBoost) {
                return this;
              }
              const copy = new CardBoost(this);
              copy._hasCardAwakenBoost = false;
              copy._cardAwakenBoost = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardBoost} other
   * @returns {CardBoost}
   */
  merge(other) {
    const copy = new CardBoost(this);
    if (other._boostTypeCase === 1) {
      copy._boostTypeCase = 1;
      copy._boostTypeValue = other._boostTypeValue;
    }
    if (other._boostTypeCase === 1) {
      if (this._boostTypeCase === 1) {
        copy._boostTypeValue = copy._boostTypeValue.merge(other._boostTypeValue);
      } else {
        copy._boostTypeValue = other._boostTypeValue;
      }
      copy._boostTypeCase = 1;
    }
    if (other._hasCardLevelBoost) {
      copy._hasCardLevelBoost = true;
      copy._cardLevelBoost = other._cardLevelBoost;
    }
    if (other._hasCardSkillLevelBoost) {
      copy._hasCardSkillLevelBoost = true;
      copy._cardSkillLevelBoost = other._cardSkillLevelBoost;
    }
    if (other._hasCardAwakenBoost) {
      copy._hasCardAwakenBoost = true;
      copy._cardAwakenBoost = other._cardAwakenBoost;
    }
    return copy;
  }
}
CardBoost.default = new CardBoost();
CardBoost.CardTypeBoost = CardBoost_CardTypeBoost;
CardBoost.CardType = CardBoost_CardType;
class CardBoost_Builder {
  constructor(value) {
    this._value = new CardBoost(value);
  }
  build() {
    return new CardBoost(this._value);
  }
  clearboostType() {
    this._value._boostTypeCase = 0;
    this._value._boostTypeValue = null;
    return this;
  }
  setCardName(value) {
    this._value._boostTypeCase = 1;
    this._value._boostTypeValue = value;
    return this;
  }
  setCardType(value) {
    this._value._boostTypeCase = 2;
    this._value._boostTypeValue = value;
    return this;
  }
  setCardLevelBoost(value) {
    this._value._hasCardLevelBoost = true;
    this._value._cardLevelBoost = value;
    return this;
  }
  deleteCardLevelBoost() {
    this._value._hasCardLevelBoost = false;
    this._value._cardLevelBoost = null;
    return this;
  }
  setCardSkillLevelBoost(value) {
    this._value._hasCardSkillLevelBoost = true;
    this._value._cardSkillLevelBoost = value;
    return this;
  }
  deleteCardSkillLevelBoost() {
    this._value._hasCardSkillLevelBoost = false;
    this._value._cardSkillLevelBoost = null;
    return this;
  }
  setCardAwakenBoost(value) {
    this._value._hasCardAwakenBoost = true;
    this._value._cardAwakenBoost = value;
    return this;
  }
  deleteCardAwakenBoost() {
    this._value._hasCardAwakenBoost = false;
    this._value._cardAwakenBoost = null;
    return this;
  }
}
CardBoost.Builder = CardBoost_Builder;
class CardBoost_WithParent {
  /**
   * @param {CardBoost} value
   * @param {CardBoost_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardBoost.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get boostTypeCase() {
    if (this._cachedboostTypeCase === undefined) {
      if (this._value._boostTypeCase === 0) {
        this._cachedboostTypeCase = this._parent ? this._parent.boostTypeCase : 0;
      } else {
        this._cachedboostTypeCase = this._value._boostTypeCase;
      }
    }
    return this._cachedboostTypeCase;
  }
  get cardName() {
    if (!this._cachedCardName) {
      if (this._value._boostTypeCase === 0) {
        this._cachedCardName = this._parent ? this._parent.cardName : this._value.cardName;
      } else {
        this._cachedCardName = this._value.cardName;
      }
    }
    return this._cachedCardName;
  }
  get cardType() {
    if (!this._cachedCardType) {
      if (this._value._boostTypeCase === 0) {
        this._cachedCardType = this._parent ? new CardBoost_CardTypeBoost.WithParent(CardBoost_CardTypeBoost.default, this._parent.cardType) : this._value.cardType;
      } else if (this._value._boostTypeCase === 2) {
        this._cachedCardType = new CardBoost_CardTypeBoost.WithParent(this._value.cardType, this._parent && this._parent.boostTypeCase === 2 ? this._parent.cardType : null);
      } else {
        this._cachedCardType = CardBoost_CardTypeBoost.WithParent.default;
      }
    }
    return this._cachedCardType;
  }
  get hasCardLevelBoost() {
    if (this._cachedHasCardLevelBoost === undefined) {
      if (this._value.hasCardLevelBoost) {
        this._cachedHasCardLevelBoost = true;
      } else {
        this._cachedHasCardLevelBoost = this._parent ? this._parent.hasCardLevelBoost : false;
      }
    }
    return this._cachedHasCardLevelBoost;
  }
  get cardLevelBoost() {
    if (this._cachedCardLevelBoost === undefined) {
      if (this._value.hasCardLevelBoost) {
        this._cachedCardLevelBoost = this._value.cardLevelBoost;
      } else {
        this._cachedCardLevelBoost = this._parent ? this._parent.cardLevelBoost : this._value.cardLevelBoost;
      }
    }
    return this._cachedCardLevelBoost;
  }
  get hasCardSkillLevelBoost() {
    if (this._cachedHasCardSkillLevelBoost === undefined) {
      if (this._value.hasCardSkillLevelBoost) {
        this._cachedHasCardSkillLevelBoost = true;
      } else {
        this._cachedHasCardSkillLevelBoost = this._parent ? this._parent.hasCardSkillLevelBoost : false;
      }
    }
    return this._cachedHasCardSkillLevelBoost;
  }
  get cardSkillLevelBoost() {
    if (this._cachedCardSkillLevelBoost === undefined) {
      if (this._value.hasCardSkillLevelBoost) {
        this._cachedCardSkillLevelBoost = this._value.cardSkillLevelBoost;
      } else {
        this._cachedCardSkillLevelBoost = this._parent ? this._parent.cardSkillLevelBoost : this._value.cardSkillLevelBoost;
      }
    }
    return this._cachedCardSkillLevelBoost;
  }
  get hasCardAwakenBoost() {
    if (this._cachedHasCardAwakenBoost === undefined) {
      if (this._value.hasCardAwakenBoost) {
        this._cachedHasCardAwakenBoost = true;
      } else {
        this._cachedHasCardAwakenBoost = this._parent ? this._parent.hasCardAwakenBoost : false;
      }
    }
    return this._cachedHasCardAwakenBoost;
  }
  get cardAwakenBoost() {
    if (this._cachedCardAwakenBoost === undefined) {
      if (this._value.hasCardAwakenBoost) {
        this._cachedCardAwakenBoost = this._value.cardAwakenBoost;
      } else {
        this._cachedCardAwakenBoost = this._parent ? this._parent.cardAwakenBoost : this._value.cardAwakenBoost;
      }
    }
    return this._cachedCardAwakenBoost;
  }
  update(current, parent) {
    const result = new CardBoost_WithParent(current, parent);
    if (this._cachedCardType && this._value._boostTypeCase === 2 && current._boostTypeCase === 2) {
      if (this._value.cardType === current.cardType && this._parent === parent) {
        result._cachedCardType = this._cachedCardType;
      } else {
        result._cachedCardType = this._cachedCardType.update(current.cardType, parent && parent.boostTypeCase === 2 ? parent.cardType : null);
      }
    }
    return result;
  }
}
CardBoost_WithParent.default = new CardBoost_WithParent(CardBoost.default, null);
CardBoost.WithParent = CardBoost_WithParent;
class CardBoost_Descriptor {
  get cardName() {
    if (!this._cardName) {
      this._cardName = {
        name: "cardName",
        Name: "CardName",
        number: 1,
        protoType: 9,
        protoName: "card_name",
        oneofIndex: 0,
        type: JsonToString,
        options: {
          valueDropdown: "CardNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardName;
  }
  get cardType() {
    if (!this._cardType) {
      this._cardType = {
        name: "cardType",
        Name: "CardType",
        number: 2,
        protoType: 11,
        protoName: "card_type",
        oneofIndex: 0,
        type: CardBoost_CardTypeBoost,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardType;
  }
  get cardLevelBoost() {
    if (!this._cardLevelBoost) {
      this._cardLevelBoost = {
        name: "cardLevelBoost",
        Name: "CardLevelBoost",
        number: 3,
        protoType: 5,
        protoName: "card_level_boost",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardLevelBoost;
  }
  get cardSkillLevelBoost() {
    if (!this._cardSkillLevelBoost) {
      this._cardSkillLevelBoost = {
        name: "cardSkillLevelBoost",
        Name: "CardSkillLevelBoost",
        number: 4,
        protoType: 5,
        protoName: "card_skill_level_boost",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardSkillLevelBoost;
  }
  get cardAwakenBoost() {
    if (!this._cardAwakenBoost) {
      this._cardAwakenBoost = {
        name: "cardAwakenBoost",
        Name: "CardAwakenBoost",
        number: 5,
        protoType: 5,
        protoName: "card_awaken_boost",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardAwakenBoost;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.cardName,
        this.cardType,
        this.cardLevelBoost,
        this.cardSkillLevelBoost,
        this.cardAwakenBoost,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "boostType",
        Name: "BoostType",
        fields: [
          this.fields[0],
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCardLevelBoost",
        Name: "DummyOneofForCardLevelBoost",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCardSkillLevelBoost",
        Name: "DummyOneofForCardSkillLevelBoost",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCardAwakenBoost",
        Name: "DummyOneofForCardAwakenBoost",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
CardBoost.descriptor = new CardBoost_Descriptor();
export class ShipTalentCardRequirement {
  get descriptor() {
    return ShipTalentCardRequirement.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCardName = false;
    this._cardName = null;
    this._hasCardLevelRequirement = false;
    this._cardLevelRequirement = null;
    this._hasCardStarRequirement = false;
    this._cardStarRequirement = null;
    this._hasCardAwakenRequirement = false;
    this._cardAwakenRequirement = null;
  }
  isEmpty() {
    if (this._hasCardName) return false;
    if (this._hasCardLevelRequirement) return false;
    if (this._hasCardStarRequirement) return false;
    if (this._hasCardAwakenRequirement) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ShipTalentCardRequirement) {
      return value;
    }
    return ShipTalentCardRequirement.fromJson(value);
  }
  static fromJson(json) {
    const result = new ShipTalentCardRequirement();
    if (json.cardName != null) {
      result._hasCardName = true;
      result._cardName = JsonToString.fromJson(json.cardName);
    }
    if (json.cardLevelRequirement != null) {
      result._hasCardLevelRequirement = true;
      result._cardLevelRequirement = JsonToInt32.fromJson(json.cardLevelRequirement);
    }
    if (json.cardStarRequirement != null) {
      result._hasCardStarRequirement = true;
      result._cardStarRequirement = JsonToInt32.fromJson(json.cardStarRequirement);
    }
    if (json.cardAwakenRequirement != null) {
      result._hasCardAwakenRequirement = true;
      result._cardAwakenRequirement = JsonToInt32.fromJson(json.cardAwakenRequirement);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCardName) {
      result.cardName = JsonToString.toJson(this._cardName);
    }
    if (this._hasCardLevelRequirement) {
      result.cardLevelRequirement = JsonToInt32.toJson(this._cardLevelRequirement);
    }
    if (this._hasCardStarRequirement) {
      result.cardStarRequirement = JsonToInt32.toJson(this._cardStarRequirement);
    }
    if (this._hasCardAwakenRequirement) {
      result.cardAwakenRequirement = JsonToInt32.toJson(this._cardAwakenRequirement);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get cardName() {
    return this._hasCardName ? this._cardName : JsonToString.default;
  }
  get hasCardName() {
    return this._hasCardName;
  }
  setCardName(path, value) {
    return {type: 'SET', path: path.concat(['cardName']), value};
  }
  deleteCardName(path) {
    return {type: 'DELETE', path: path.concat(['cardName'])};
  }
  /**
   * @returns {number}
   */
  get cardLevelRequirement() {
    return this._hasCardLevelRequirement ? this._cardLevelRequirement : JsonToInt32.default;
  }
  get hasCardLevelRequirement() {
    return this._hasCardLevelRequirement;
  }
  setCardLevelRequirement(path, value) {
    return {type: 'SET', path: path.concat(['cardLevelRequirement']), value};
  }
  deleteCardLevelRequirement(path) {
    return {type: 'DELETE', path: path.concat(['cardLevelRequirement'])};
  }
  /**
   * @returns {number}
   */
  get cardStarRequirement() {
    return this._hasCardStarRequirement ? this._cardStarRequirement : JsonToInt32.default;
  }
  get hasCardStarRequirement() {
    return this._hasCardStarRequirement;
  }
  setCardStarRequirement(path, value) {
    return {type: 'SET', path: path.concat(['cardStarRequirement']), value};
  }
  deleteCardStarRequirement(path) {
    return {type: 'DELETE', path: path.concat(['cardStarRequirement'])};
  }
  /**
   * @returns {number}
   */
  get cardAwakenRequirement() {
    return this._hasCardAwakenRequirement ? this._cardAwakenRequirement : JsonToInt32.default;
  }
  get hasCardAwakenRequirement() {
    return this._hasCardAwakenRequirement;
  }
  setCardAwakenRequirement(path, value) {
    return {type: 'SET', path: path.concat(['cardAwakenRequirement']), value};
  }
  deleteCardAwakenRequirement(path) {
    return {type: 'DELETE', path: path.concat(['cardAwakenRequirement'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "cardName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipTalentCardRequirement(this);
              copy._hasCardName = true;
              copy._cardName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardName) {
                return this;
              }
              const copy = new ShipTalentCardRequirement(this);
              copy._hasCardName = false;
              copy._cardName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cardLevelRequirement": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipTalentCardRequirement(this);
              copy._hasCardLevelRequirement = true;
              copy._cardLevelRequirement = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardLevelRequirement) {
                return this;
              }
              const copy = new ShipTalentCardRequirement(this);
              copy._hasCardLevelRequirement = false;
              copy._cardLevelRequirement = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cardStarRequirement": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipTalentCardRequirement(this);
              copy._hasCardStarRequirement = true;
              copy._cardStarRequirement = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardStarRequirement) {
                return this;
              }
              const copy = new ShipTalentCardRequirement(this);
              copy._hasCardStarRequirement = false;
              copy._cardStarRequirement = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cardAwakenRequirement": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipTalentCardRequirement(this);
              copy._hasCardAwakenRequirement = true;
              copy._cardAwakenRequirement = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardAwakenRequirement) {
                return this;
              }
              const copy = new ShipTalentCardRequirement(this);
              copy._hasCardAwakenRequirement = false;
              copy._cardAwakenRequirement = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ShipTalentCardRequirement} other
   * @returns {ShipTalentCardRequirement}
   */
  merge(other) {
    const copy = new ShipTalentCardRequirement(this);
    if (other._hasCardName) {
      copy._hasCardName = true;
      copy._cardName = other._cardName;
    }
    if (other._hasCardLevelRequirement) {
      copy._hasCardLevelRequirement = true;
      copy._cardLevelRequirement = other._cardLevelRequirement;
    }
    if (other._hasCardStarRequirement) {
      copy._hasCardStarRequirement = true;
      copy._cardStarRequirement = other._cardStarRequirement;
    }
    if (other._hasCardAwakenRequirement) {
      copy._hasCardAwakenRequirement = true;
      copy._cardAwakenRequirement = other._cardAwakenRequirement;
    }
    return copy;
  }
}
ShipTalentCardRequirement.default = new ShipTalentCardRequirement();
class ShipTalentCardRequirement_Builder {
  constructor(value) {
    this._value = new ShipTalentCardRequirement(value);
  }
  build() {
    return new ShipTalentCardRequirement(this._value);
  }
  setCardName(value) {
    this._value._hasCardName = true;
    this._value._cardName = value;
    return this;
  }
  deleteCardName() {
    this._value._hasCardName = false;
    this._value._cardName = null;
    return this;
  }
  setCardLevelRequirement(value) {
    this._value._hasCardLevelRequirement = true;
    this._value._cardLevelRequirement = value;
    return this;
  }
  deleteCardLevelRequirement() {
    this._value._hasCardLevelRequirement = false;
    this._value._cardLevelRequirement = null;
    return this;
  }
  setCardStarRequirement(value) {
    this._value._hasCardStarRequirement = true;
    this._value._cardStarRequirement = value;
    return this;
  }
  deleteCardStarRequirement() {
    this._value._hasCardStarRequirement = false;
    this._value._cardStarRequirement = null;
    return this;
  }
  setCardAwakenRequirement(value) {
    this._value._hasCardAwakenRequirement = true;
    this._value._cardAwakenRequirement = value;
    return this;
  }
  deleteCardAwakenRequirement() {
    this._value._hasCardAwakenRequirement = false;
    this._value._cardAwakenRequirement = null;
    return this;
  }
}
ShipTalentCardRequirement.Builder = ShipTalentCardRequirement_Builder;
class ShipTalentCardRequirement_WithParent {
  /**
   * @param {ShipTalentCardRequirement} value
   * @param {ShipTalentCardRequirement_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ShipTalentCardRequirement.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCardName() {
    if (this._cachedHasCardName === undefined) {
      if (this._value.hasCardName) {
        this._cachedHasCardName = true;
      } else {
        this._cachedHasCardName = this._parent ? this._parent.hasCardName : false;
      }
    }
    return this._cachedHasCardName;
  }
  get cardName() {
    if (this._cachedCardName === undefined) {
      if (this._value.hasCardName) {
        this._cachedCardName = this._value.cardName;
      } else {
        this._cachedCardName = this._parent ? this._parent.cardName : this._value.cardName;
      }
    }
    return this._cachedCardName;
  }
  get hasCardLevelRequirement() {
    if (this._cachedHasCardLevelRequirement === undefined) {
      if (this._value.hasCardLevelRequirement) {
        this._cachedHasCardLevelRequirement = true;
      } else {
        this._cachedHasCardLevelRequirement = this._parent ? this._parent.hasCardLevelRequirement : false;
      }
    }
    return this._cachedHasCardLevelRequirement;
  }
  get cardLevelRequirement() {
    if (this._cachedCardLevelRequirement === undefined) {
      if (this._value.hasCardLevelRequirement) {
        this._cachedCardLevelRequirement = this._value.cardLevelRequirement;
      } else {
        this._cachedCardLevelRequirement = this._parent ? this._parent.cardLevelRequirement : this._value.cardLevelRequirement;
      }
    }
    return this._cachedCardLevelRequirement;
  }
  get hasCardStarRequirement() {
    if (this._cachedHasCardStarRequirement === undefined) {
      if (this._value.hasCardStarRequirement) {
        this._cachedHasCardStarRequirement = true;
      } else {
        this._cachedHasCardStarRequirement = this._parent ? this._parent.hasCardStarRequirement : false;
      }
    }
    return this._cachedHasCardStarRequirement;
  }
  get cardStarRequirement() {
    if (this._cachedCardStarRequirement === undefined) {
      if (this._value.hasCardStarRequirement) {
        this._cachedCardStarRequirement = this._value.cardStarRequirement;
      } else {
        this._cachedCardStarRequirement = this._parent ? this._parent.cardStarRequirement : this._value.cardStarRequirement;
      }
    }
    return this._cachedCardStarRequirement;
  }
  get hasCardAwakenRequirement() {
    if (this._cachedHasCardAwakenRequirement === undefined) {
      if (this._value.hasCardAwakenRequirement) {
        this._cachedHasCardAwakenRequirement = true;
      } else {
        this._cachedHasCardAwakenRequirement = this._parent ? this._parent.hasCardAwakenRequirement : false;
      }
    }
    return this._cachedHasCardAwakenRequirement;
  }
  get cardAwakenRequirement() {
    if (this._cachedCardAwakenRequirement === undefined) {
      if (this._value.hasCardAwakenRequirement) {
        this._cachedCardAwakenRequirement = this._value.cardAwakenRequirement;
      } else {
        this._cachedCardAwakenRequirement = this._parent ? this._parent.cardAwakenRequirement : this._value.cardAwakenRequirement;
      }
    }
    return this._cachedCardAwakenRequirement;
  }
  update(current, parent) {
    const result = new ShipTalentCardRequirement_WithParent(current, parent);
    return result;
  }
}
ShipTalentCardRequirement_WithParent.default = new ShipTalentCardRequirement_WithParent(ShipTalentCardRequirement.default, null);
ShipTalentCardRequirement.WithParent = ShipTalentCardRequirement_WithParent;
class ShipTalentCardRequirement_Descriptor {
  get cardName() {
    if (!this._cardName) {
      this._cardName = {
        name: "cardName",
        Name: "CardName",
        number: 1,
        protoType: 9,
        protoName: "card_name",
        type: JsonToString,
        options: {
          valueDropdown: "CardNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardName;
  }
  get cardLevelRequirement() {
    if (!this._cardLevelRequirement) {
      this._cardLevelRequirement = {
        name: "cardLevelRequirement",
        Name: "CardLevelRequirement",
        number: 2,
        protoType: 5,
        protoName: "card_level_requirement",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardLevelRequirement;
  }
  get cardStarRequirement() {
    if (!this._cardStarRequirement) {
      this._cardStarRequirement = {
        name: "cardStarRequirement",
        Name: "CardStarRequirement",
        number: 3,
        protoType: 5,
        protoName: "card_star_requirement",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardStarRequirement;
  }
  get cardAwakenRequirement() {
    if (!this._cardAwakenRequirement) {
      this._cardAwakenRequirement = {
        name: "cardAwakenRequirement",
        Name: "CardAwakenRequirement",
        number: 4,
        protoType: 5,
        protoName: "card_awaken_requirement",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardAwakenRequirement;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.cardName,
        this.cardLevelRequirement,
        this.cardStarRequirement,
        this.cardAwakenRequirement,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCardName",
        Name: "DummyOneofForCardName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCardLevelRequirement",
        Name: "DummyOneofForCardLevelRequirement",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCardStarRequirement",
        Name: "DummyOneofForCardStarRequirement",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCardAwakenRequirement",
        Name: "DummyOneofForCardAwakenRequirement",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
ShipTalentCardRequirement.descriptor = new ShipTalentCardRequirement_Descriptor();
export class ShipTalentDefinition {
  get descriptor() {
    return ShipTalentDefinition.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasName = false;
    this._name = null;
    this._hasDisplayName = false;
    this._displayName = null;
    this._hasDescription = false;
    this._description = null;
    this._hasDescription2 = false;
    this._description2 = null;
    this._hasIcon = false;
    this._icon = null;
    this._hasShipTierRequirement = false;
    this._shipTierRequirement = null;
    this._upgrades = [];
    this._unlockedAbilities = [];
    this._unlockedWeapons = [];
    this._unlockedBehaviors = [];
    this._cardBoosts = [];
    this._cardRequirements = [];
    this._subTalents = [];
  }
  isEmpty() {
    if (this._hasName) return false;
    if (this._hasDisplayName) return false;
    if (this._hasDescription) return false;
    if (this._hasDescription2) return false;
    if (this._hasIcon) return false;
    if (this._hasShipTierRequirement) return false;
    if (this._upgrades.length > 0) return false;
    if (this._unlockedAbilities.length > 0) return false;
    if (this._unlockedWeapons.length > 0) return false;
    if (this._unlockedBehaviors.length > 0) return false;
    if (this._cardBoosts.length > 0) return false;
    if (this._cardRequirements.length > 0) return false;
    if (this._subTalents.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ShipTalentDefinition) {
      return value;
    }
    return ShipTalentDefinition.fromJson(value);
  }
  static fromJson(json) {
    const result = new ShipTalentDefinition();
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    if (json.displayName != null) {
      result._hasDisplayName = true;
      result._displayName = JsonToString.fromJson(json.displayName);
    }
    if (json.description != null) {
      result._hasDescription = true;
      result._description = JsonToString.fromJson(json.description);
    }
    if (json.description2 != null) {
      result._hasDescription2 = true;
      result._description2 = JsonToString.fromJson(json.description2);
    }
    if (json.icon != null) {
      result._hasIcon = true;
      result._icon = JsonToString.fromJson(json.icon);
    }
    if (json.shipTierRequirement != null) {
      result._hasShipTierRequirement = true;
      result._shipTierRequirement = JsonToInt32.fromJson(json.shipTierRequirement);
    }
    result._upgrades = JsonToList(json.upgrades, JsonToString);
    result._unlockedAbilities = JsonToList(json.unlockedAbilities, JsonToString);
    result._unlockedWeapons = JsonToList(json.unlockedWeapons, JsonToString);
    result._unlockedBehaviors = JsonToList(json.unlockedBehaviors, JsonToString);
    result._cardBoosts = JsonToList(json.cardBoosts, CardBoost);
    result._cardRequirements = JsonToList(json.cardRequirements, ShipTalentCardRequirement);
    result._subTalents = JsonToList(json.subTalents, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._hasDisplayName) {
      result.displayName = JsonToString.toJson(this._displayName);
    }
    if (this._hasDescription) {
      result.description = JsonToString.toJson(this._description);
    }
    if (this._hasDescription2) {
      result.description2 = JsonToString.toJson(this._description2);
    }
    if (this._hasIcon) {
      result.icon = JsonToString.toJson(this._icon);
    }
    if (this._hasShipTierRequirement) {
      result.shipTierRequirement = JsonToInt32.toJson(this._shipTierRequirement);
    }
    if (this._upgrades.length > 0) {
      result.upgrades = ArrayToJson(this._upgrades, JsonToString);
    }
    if (this._unlockedAbilities.length > 0) {
      result.unlockedAbilities = ArrayToJson(this._unlockedAbilities, JsonToString);
    }
    if (this._unlockedWeapons.length > 0) {
      result.unlockedWeapons = ArrayToJson(this._unlockedWeapons, JsonToString);
    }
    if (this._unlockedBehaviors.length > 0) {
      result.unlockedBehaviors = ArrayToJson(this._unlockedBehaviors, JsonToString);
    }
    if (this._cardBoosts.length > 0) {
      result.cardBoosts = ArrayToJson(this._cardBoosts, CardBoost);
    }
    if (this._cardRequirements.length > 0) {
      result.cardRequirements = ArrayToJson(this._cardRequirements, ShipTalentCardRequirement);
    }
    if (this._subTalents.length > 0) {
      result.subTalents = ArrayToJson(this._subTalents, JsonToString);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {string}
   */
  get displayName() {
    return this._hasDisplayName ? this._displayName : JsonToString.default;
  }
  get hasDisplayName() {
    return this._hasDisplayName;
  }
  setDisplayName(path, value) {
    return {type: 'SET', path: path.concat(['displayName']), value};
  }
  deleteDisplayName(path) {
    return {type: 'DELETE', path: path.concat(['displayName'])};
  }
  /**
   * @returns {string}
   */
  get description() {
    return this._hasDescription ? this._description : JsonToString.default;
  }
  get hasDescription() {
    return this._hasDescription;
  }
  setDescription(path, value) {
    return {type: 'SET', path: path.concat(['description']), value};
  }
  deleteDescription(path) {
    return {type: 'DELETE', path: path.concat(['description'])};
  }
  /**
   * @returns {string}
   */
  get description2() {
    return this._hasDescription2 ? this._description2 : JsonToString.default;
  }
  get hasDescription2() {
    return this._hasDescription2;
  }
  setDescription2(path, value) {
    return {type: 'SET', path: path.concat(['description2']), value};
  }
  deleteDescription2(path) {
    return {type: 'DELETE', path: path.concat(['description2'])};
  }
  /**
   * @returns {string}
   */
  get icon() {
    return this._hasIcon ? this._icon : JsonToString.default;
  }
  get hasIcon() {
    return this._hasIcon;
  }
  setIcon(path, value) {
    return {type: 'SET', path: path.concat(['icon']), value};
  }
  deleteIcon(path) {
    return {type: 'DELETE', path: path.concat(['icon'])};
  }
  /**
   * @returns {number}
   */
  get shipTierRequirement() {
    return this._hasShipTierRequirement ? this._shipTierRequirement : JsonToInt32.default;
  }
  get hasShipTierRequirement() {
    return this._hasShipTierRequirement;
  }
  setShipTierRequirement(path, value) {
    return {type: 'SET', path: path.concat(['shipTierRequirement']), value};
  }
  deleteShipTierRequirement(path) {
    return {type: 'DELETE', path: path.concat(['shipTierRequirement'])};
  }
  /**
   * @returns {string[]}
   */
  get upgrades() {
    return this._upgrades;
  }
  addUpgrades(path, value) {
    return {type: 'ADD', path: path.concat(['upgrades']), value};
  }
  setUpgrades(path, value) {
    return {type: 'SET', path: path.concat(['upgrades']), value: ArrayToJson(value, JsonToString)};
  }
  setUpgradesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['upgrades', key]), value};
  }
  deleteUpgrades(path) {
    return {type: 'DELETE', path: path.concat(['upgrades'])};
  }
  deleteUpgradesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['upgrades', key])};
  }
  /**
   * @returns {string[]}
   */
  get unlockedAbilities() {
    return this._unlockedAbilities;
  }
  addUnlockedAbilities(path, value) {
    return {type: 'ADD', path: path.concat(['unlockedAbilities']), value};
  }
  setUnlockedAbilities(path, value) {
    return {type: 'SET', path: path.concat(['unlockedAbilities']), value: ArrayToJson(value, JsonToString)};
  }
  setUnlockedAbilitiesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['unlockedAbilities', key]), value};
  }
  deleteUnlockedAbilities(path) {
    return {type: 'DELETE', path: path.concat(['unlockedAbilities'])};
  }
  deleteUnlockedAbilitiesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['unlockedAbilities', key])};
  }
  /**
   * @returns {string[]}
   */
  get unlockedWeapons() {
    return this._unlockedWeapons;
  }
  addUnlockedWeapons(path, value) {
    return {type: 'ADD', path: path.concat(['unlockedWeapons']), value};
  }
  setUnlockedWeapons(path, value) {
    return {type: 'SET', path: path.concat(['unlockedWeapons']), value: ArrayToJson(value, JsonToString)};
  }
  setUnlockedWeaponsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['unlockedWeapons', key]), value};
  }
  deleteUnlockedWeapons(path) {
    return {type: 'DELETE', path: path.concat(['unlockedWeapons'])};
  }
  deleteUnlockedWeaponsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['unlockedWeapons', key])};
  }
  /**
   * @returns {string[]}
   */
  get unlockedBehaviors() {
    return this._unlockedBehaviors;
  }
  addUnlockedBehaviors(path, value) {
    return {type: 'ADD', path: path.concat(['unlockedBehaviors']), value};
  }
  setUnlockedBehaviors(path, value) {
    return {type: 'SET', path: path.concat(['unlockedBehaviors']), value: ArrayToJson(value, JsonToString)};
  }
  setUnlockedBehaviorsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['unlockedBehaviors', key]), value};
  }
  deleteUnlockedBehaviors(path) {
    return {type: 'DELETE', path: path.concat(['unlockedBehaviors'])};
  }
  deleteUnlockedBehaviorsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['unlockedBehaviors', key])};
  }
  /**
   * @returns {CardBoost[]}
   */
  get cardBoosts() {
    return this._cardBoosts;
  }
  addCardBoosts(path, value) {
    return {type: 'ADD', path: path.concat(['cardBoosts']), value: value.toJson()};
  }
  setCardBoosts(path, value) {
    return {type: 'SET', path: path.concat(['cardBoosts']), value: ArrayToJson(value, CardBoost)};
  }
  setCardBoostsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['cardBoosts', key]), value: value.toJson()};
  }
  deleteCardBoosts(path) {
    return {type: 'DELETE', path: path.concat(['cardBoosts'])};
  }
  deleteCardBoostsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['cardBoosts', key])};
  }
  /**
   * @returns {ShipTalentCardRequirement[]}
   */
  get cardRequirements() {
    return this._cardRequirements;
  }
  addCardRequirements(path, value) {
    return {type: 'ADD', path: path.concat(['cardRequirements']), value: value.toJson()};
  }
  setCardRequirements(path, value) {
    return {type: 'SET', path: path.concat(['cardRequirements']), value: ArrayToJson(value, ShipTalentCardRequirement)};
  }
  setCardRequirementsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['cardRequirements', key]), value: value.toJson()};
  }
  deleteCardRequirements(path) {
    return {type: 'DELETE', path: path.concat(['cardRequirements'])};
  }
  deleteCardRequirementsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['cardRequirements', key])};
  }
  /**
   * @returns {string[]}
   */
  get subTalents() {
    return this._subTalents;
  }
  addSubTalents(path, value) {
    return {type: 'ADD', path: path.concat(['subTalents']), value};
  }
  setSubTalents(path, value) {
    return {type: 'SET', path: path.concat(['subTalents']), value: ArrayToJson(value, JsonToString)};
  }
  setSubTalentsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['subTalents', key]), value};
  }
  deleteSubTalents(path) {
    return {type: 'DELETE', path: path.concat(['subTalents'])};
  }
  deleteSubTalentsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['subTalents', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipTalentDefinition(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new ShipTalentDefinition(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipTalentDefinition(this);
              copy._hasDisplayName = true;
              copy._displayName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayName) {
                return this;
              }
              const copy = new ShipTalentDefinition(this);
              copy._hasDisplayName = false;
              copy._displayName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "description": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipTalentDefinition(this);
              copy._hasDescription = true;
              copy._description = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDescription) {
                return this;
              }
              const copy = new ShipTalentDefinition(this);
              copy._hasDescription = false;
              copy._description = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "description2": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipTalentDefinition(this);
              copy._hasDescription2 = true;
              copy._description2 = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDescription2) {
                return this;
              }
              const copy = new ShipTalentDefinition(this);
              copy._hasDescription2 = false;
              copy._description2 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "icon": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipTalentDefinition(this);
              copy._hasIcon = true;
              copy._icon = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIcon) {
                return this;
              }
              const copy = new ShipTalentDefinition(this);
              copy._hasIcon = false;
              copy._icon = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "shipTierRequirement": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipTalentDefinition(this);
              copy._hasShipTierRequirement = true;
              copy._shipTierRequirement = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShipTierRequirement) {
                return this;
              }
              const copy = new ShipTalentDefinition(this);
              copy._hasShipTierRequirement = false;
              copy._shipTierRequirement = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "upgrades": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipTalentDefinition(this);
              copy._upgrades = [];        for (let i of value) {
                copy._upgrades.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ShipTalentDefinition(this);
              copy._upgrades = copy._upgrades.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._upgrades.length === 0) {
                return this;
              }
              const copy = new ShipTalentDefinition(this);
              copy._upgrades = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._upgrades.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ShipTalentDefinition(this);
              copy._upgrades = copy._upgrades.slice();
              copy._upgrades[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ShipTalentDefinition(this);
              copy._upgrades = copy._upgrades.slice(0, path[1]).concat(copy._upgrades.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._upgrades.length) {
            return this;
          }
          const oldValue = this._upgrades[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ShipTalentDefinition(this);
          copy._upgrades = copy._upgrades.slice();
          copy._upgrades[key] = newValue;
          return copy;
        }
      }
      case "unlockedAbilities": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipTalentDefinition(this);
              copy._unlockedAbilities = [];        for (let i of value) {
                copy._unlockedAbilities.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ShipTalentDefinition(this);
              copy._unlockedAbilities = copy._unlockedAbilities.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._unlockedAbilities.length === 0) {
                return this;
              }
              const copy = new ShipTalentDefinition(this);
              copy._unlockedAbilities = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._unlockedAbilities.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ShipTalentDefinition(this);
              copy._unlockedAbilities = copy._unlockedAbilities.slice();
              copy._unlockedAbilities[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ShipTalentDefinition(this);
              copy._unlockedAbilities = copy._unlockedAbilities.slice(0, path[1]).concat(copy._unlockedAbilities.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._unlockedAbilities.length) {
            return this;
          }
          const oldValue = this._unlockedAbilities[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ShipTalentDefinition(this);
          copy._unlockedAbilities = copy._unlockedAbilities.slice();
          copy._unlockedAbilities[key] = newValue;
          return copy;
        }
      }
      case "unlockedWeapons": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipTalentDefinition(this);
              copy._unlockedWeapons = [];        for (let i of value) {
                copy._unlockedWeapons.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ShipTalentDefinition(this);
              copy._unlockedWeapons = copy._unlockedWeapons.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._unlockedWeapons.length === 0) {
                return this;
              }
              const copy = new ShipTalentDefinition(this);
              copy._unlockedWeapons = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._unlockedWeapons.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ShipTalentDefinition(this);
              copy._unlockedWeapons = copy._unlockedWeapons.slice();
              copy._unlockedWeapons[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ShipTalentDefinition(this);
              copy._unlockedWeapons = copy._unlockedWeapons.slice(0, path[1]).concat(copy._unlockedWeapons.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._unlockedWeapons.length) {
            return this;
          }
          const oldValue = this._unlockedWeapons[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ShipTalentDefinition(this);
          copy._unlockedWeapons = copy._unlockedWeapons.slice();
          copy._unlockedWeapons[key] = newValue;
          return copy;
        }
      }
      case "unlockedBehaviors": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipTalentDefinition(this);
              copy._unlockedBehaviors = [];        for (let i of value) {
                copy._unlockedBehaviors.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ShipTalentDefinition(this);
              copy._unlockedBehaviors = copy._unlockedBehaviors.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._unlockedBehaviors.length === 0) {
                return this;
              }
              const copy = new ShipTalentDefinition(this);
              copy._unlockedBehaviors = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._unlockedBehaviors.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ShipTalentDefinition(this);
              copy._unlockedBehaviors = copy._unlockedBehaviors.slice();
              copy._unlockedBehaviors[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ShipTalentDefinition(this);
              copy._unlockedBehaviors = copy._unlockedBehaviors.slice(0, path[1]).concat(copy._unlockedBehaviors.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._unlockedBehaviors.length) {
            return this;
          }
          const oldValue = this._unlockedBehaviors[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ShipTalentDefinition(this);
          copy._unlockedBehaviors = copy._unlockedBehaviors.slice();
          copy._unlockedBehaviors[key] = newValue;
          return copy;
        }
      }
      case "cardBoosts": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipTalentDefinition(this);
              copy._cardBoosts = [];        for (let i of value) {
                copy._cardBoosts.push(CardBoost.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ShipTalentDefinition(this);
              copy._cardBoosts = copy._cardBoosts.concat([CardBoost.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._cardBoosts.length === 0) {
                return this;
              }
              const copy = new ShipTalentDefinition(this);
              copy._cardBoosts = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._cardBoosts.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ShipTalentDefinition(this);
              copy._cardBoosts = copy._cardBoosts.slice();
              copy._cardBoosts[path[1]] = CardBoost.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ShipTalentDefinition(this);
              copy._cardBoosts = copy._cardBoosts.slice(0, path[1]).concat(copy._cardBoosts.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._cardBoosts.length) {
            return this;
          }
          const oldValue = this._cardBoosts[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ShipTalentDefinition(this);
          copy._cardBoosts = copy._cardBoosts.slice();
          copy._cardBoosts[key] = newValue;
          return copy;
        }
      }
      case "cardRequirements": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipTalentDefinition(this);
              copy._cardRequirements = [];        for (let i of value) {
                copy._cardRequirements.push(ShipTalentCardRequirement.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ShipTalentDefinition(this);
              copy._cardRequirements = copy._cardRequirements.concat([ShipTalentCardRequirement.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._cardRequirements.length === 0) {
                return this;
              }
              const copy = new ShipTalentDefinition(this);
              copy._cardRequirements = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._cardRequirements.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ShipTalentDefinition(this);
              copy._cardRequirements = copy._cardRequirements.slice();
              copy._cardRequirements[path[1]] = ShipTalentCardRequirement.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ShipTalentDefinition(this);
              copy._cardRequirements = copy._cardRequirements.slice(0, path[1]).concat(copy._cardRequirements.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._cardRequirements.length) {
            return this;
          }
          const oldValue = this._cardRequirements[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ShipTalentDefinition(this);
          copy._cardRequirements = copy._cardRequirements.slice();
          copy._cardRequirements[key] = newValue;
          return copy;
        }
      }
      case "subTalents": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipTalentDefinition(this);
              copy._subTalents = [];        for (let i of value) {
                copy._subTalents.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ShipTalentDefinition(this);
              copy._subTalents = copy._subTalents.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._subTalents.length === 0) {
                return this;
              }
              const copy = new ShipTalentDefinition(this);
              copy._subTalents = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._subTalents.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ShipTalentDefinition(this);
              copy._subTalents = copy._subTalents.slice();
              copy._subTalents[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ShipTalentDefinition(this);
              copy._subTalents = copy._subTalents.slice(0, path[1]).concat(copy._subTalents.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._subTalents.length) {
            return this;
          }
          const oldValue = this._subTalents[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ShipTalentDefinition(this);
          copy._subTalents = copy._subTalents.slice();
          copy._subTalents[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ShipTalentDefinition} other
   * @returns {ShipTalentDefinition}
   */
  merge(other) {
    const copy = new ShipTalentDefinition(this);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    if (other._hasDisplayName) {
      copy._hasDisplayName = true;
      copy._displayName = other._displayName;
    }
    if (other._hasDescription) {
      copy._hasDescription = true;
      copy._description = other._description;
    }
    if (other._hasDescription2) {
      copy._hasDescription2 = true;
      copy._description2 = other._description2;
    }
    if (other._hasIcon) {
      copy._hasIcon = true;
      copy._icon = other._icon;
    }
    if (other._hasShipTierRequirement) {
      copy._hasShipTierRequirement = true;
      copy._shipTierRequirement = other._shipTierRequirement;
    }
    copy._upgrades = this._upgrades.concat(other._upgrades);
    copy._unlockedAbilities = this._unlockedAbilities.concat(other._unlockedAbilities);
    copy._unlockedWeapons = this._unlockedWeapons.concat(other._unlockedWeapons);
    copy._unlockedBehaviors = this._unlockedBehaviors.concat(other._unlockedBehaviors);
    copy._cardBoosts = this._cardBoosts.concat(other._cardBoosts);
    copy._cardRequirements = this._cardRequirements.concat(other._cardRequirements);
    copy._subTalents = this._subTalents.concat(other._subTalents);
    return copy;
  }
}
ShipTalentDefinition.default = new ShipTalentDefinition();
class ShipTalentDefinition_Builder {
  constructor(value) {
    this._value = new ShipTalentDefinition(value);
  }
  build() {
    return new ShipTalentDefinition(this._value);
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  setDisplayName(value) {
    this._value._hasDisplayName = true;
    this._value._displayName = value;
    return this;
  }
  deleteDisplayName() {
    this._value._hasDisplayName = false;
    this._value._displayName = null;
    return this;
  }
  setDescription(value) {
    this._value._hasDescription = true;
    this._value._description = value;
    return this;
  }
  deleteDescription() {
    this._value._hasDescription = false;
    this._value._description = null;
    return this;
  }
  setDescription2(value) {
    this._value._hasDescription2 = true;
    this._value._description2 = value;
    return this;
  }
  deleteDescription2() {
    this._value._hasDescription2 = false;
    this._value._description2 = null;
    return this;
  }
  setIcon(value) {
    this._value._hasIcon = true;
    this._value._icon = value;
    return this;
  }
  deleteIcon() {
    this._value._hasIcon = false;
    this._value._icon = null;
    return this;
  }
  setShipTierRequirement(value) {
    this._value._hasShipTierRequirement = true;
    this._value._shipTierRequirement = value;
    return this;
  }
  deleteShipTierRequirement() {
    this._value._hasShipTierRequirement = false;
    this._value._shipTierRequirement = null;
    return this;
  }
  addAllUpgrades(values) {
    this._value._upgrades = this._value._upgrades.concat(values);
    return this;
  }
  addUpgrades(value) {
    this._value._upgrades = this._value._upgrades.concat([value]);
    return this;
  }
  setUpgrades(index, value) {
    this._value._upgrades = this._value._upgrades.concat();
    this._value._upgrades[index] = value;
    return this;
  }
  clearUpgrades() {
    this._value._upgrades = [];
    return this;
  }
  addAllUnlockedAbilities(values) {
    this._value._unlockedAbilities = this._value._unlockedAbilities.concat(values);
    return this;
  }
  addUnlockedAbilities(value) {
    this._value._unlockedAbilities = this._value._unlockedAbilities.concat([value]);
    return this;
  }
  setUnlockedAbilities(index, value) {
    this._value._unlockedAbilities = this._value._unlockedAbilities.concat();
    this._value._unlockedAbilities[index] = value;
    return this;
  }
  clearUnlockedAbilities() {
    this._value._unlockedAbilities = [];
    return this;
  }
  addAllUnlockedWeapons(values) {
    this._value._unlockedWeapons = this._value._unlockedWeapons.concat(values);
    return this;
  }
  addUnlockedWeapons(value) {
    this._value._unlockedWeapons = this._value._unlockedWeapons.concat([value]);
    return this;
  }
  setUnlockedWeapons(index, value) {
    this._value._unlockedWeapons = this._value._unlockedWeapons.concat();
    this._value._unlockedWeapons[index] = value;
    return this;
  }
  clearUnlockedWeapons() {
    this._value._unlockedWeapons = [];
    return this;
  }
  addAllUnlockedBehaviors(values) {
    this._value._unlockedBehaviors = this._value._unlockedBehaviors.concat(values);
    return this;
  }
  addUnlockedBehaviors(value) {
    this._value._unlockedBehaviors = this._value._unlockedBehaviors.concat([value]);
    return this;
  }
  setUnlockedBehaviors(index, value) {
    this._value._unlockedBehaviors = this._value._unlockedBehaviors.concat();
    this._value._unlockedBehaviors[index] = value;
    return this;
  }
  clearUnlockedBehaviors() {
    this._value._unlockedBehaviors = [];
    return this;
  }
  addAllCardBoosts(values) {
    this._value._cardBoosts = this._value._cardBoosts.concat(values);
    return this;
  }
  addCardBoosts(value) {
    this._value._cardBoosts = this._value._cardBoosts.concat([value]);
    return this;
  }
  setCardBoosts(index, value) {
    this._value._cardBoosts = this._value._cardBoosts.concat();
    this._value._cardBoosts[index] = value;
    return this;
  }
  clearCardBoosts() {
    this._value._cardBoosts = [];
    return this;
  }
  addAllCardRequirements(values) {
    this._value._cardRequirements = this._value._cardRequirements.concat(values);
    return this;
  }
  addCardRequirements(value) {
    this._value._cardRequirements = this._value._cardRequirements.concat([value]);
    return this;
  }
  setCardRequirements(index, value) {
    this._value._cardRequirements = this._value._cardRequirements.concat();
    this._value._cardRequirements[index] = value;
    return this;
  }
  clearCardRequirements() {
    this._value._cardRequirements = [];
    return this;
  }
  addAllSubTalents(values) {
    this._value._subTalents = this._value._subTalents.concat(values);
    return this;
  }
  addSubTalents(value) {
    this._value._subTalents = this._value._subTalents.concat([value]);
    return this;
  }
  setSubTalents(index, value) {
    this._value._subTalents = this._value._subTalents.concat();
    this._value._subTalents[index] = value;
    return this;
  }
  clearSubTalents() {
    this._value._subTalents = [];
    return this;
  }
}
ShipTalentDefinition.Builder = ShipTalentDefinition_Builder;
class ShipTalentDefinition_WithParent {
  /**
   * @param {ShipTalentDefinition} value
   * @param {ShipTalentDefinition_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ShipTalentDefinition.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get hasDisplayName() {
    if (this._cachedHasDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedHasDisplayName = true;
      } else {
        this._cachedHasDisplayName = this._parent ? this._parent.hasDisplayName : false;
      }
    }
    return this._cachedHasDisplayName;
  }
  get displayName() {
    if (this._cachedDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedDisplayName = this._value.displayName;
      } else {
        this._cachedDisplayName = this._parent ? this._parent.displayName : this._value.displayName;
      }
    }
    return this._cachedDisplayName;
  }
  get hasDescription() {
    if (this._cachedHasDescription === undefined) {
      if (this._value.hasDescription) {
        this._cachedHasDescription = true;
      } else {
        this._cachedHasDescription = this._parent ? this._parent.hasDescription : false;
      }
    }
    return this._cachedHasDescription;
  }
  get description() {
    if (this._cachedDescription === undefined) {
      if (this._value.hasDescription) {
        this._cachedDescription = this._value.description;
      } else {
        this._cachedDescription = this._parent ? this._parent.description : this._value.description;
      }
    }
    return this._cachedDescription;
  }
  get hasDescription2() {
    if (this._cachedHasDescription2 === undefined) {
      if (this._value.hasDescription2) {
        this._cachedHasDescription2 = true;
      } else {
        this._cachedHasDescription2 = this._parent ? this._parent.hasDescription2 : false;
      }
    }
    return this._cachedHasDescription2;
  }
  get description2() {
    if (this._cachedDescription2 === undefined) {
      if (this._value.hasDescription2) {
        this._cachedDescription2 = this._value.description2;
      } else {
        this._cachedDescription2 = this._parent ? this._parent.description2 : this._value.description2;
      }
    }
    return this._cachedDescription2;
  }
  get hasIcon() {
    if (this._cachedHasIcon === undefined) {
      if (this._value.hasIcon) {
        this._cachedHasIcon = true;
      } else {
        this._cachedHasIcon = this._parent ? this._parent.hasIcon : false;
      }
    }
    return this._cachedHasIcon;
  }
  get icon() {
    if (this._cachedIcon === undefined) {
      if (this._value.hasIcon) {
        this._cachedIcon = this._value.icon;
      } else {
        this._cachedIcon = this._parent ? this._parent.icon : this._value.icon;
      }
    }
    return this._cachedIcon;
  }
  get hasShipTierRequirement() {
    if (this._cachedHasShipTierRequirement === undefined) {
      if (this._value.hasShipTierRequirement) {
        this._cachedHasShipTierRequirement = true;
      } else {
        this._cachedHasShipTierRequirement = this._parent ? this._parent.hasShipTierRequirement : false;
      }
    }
    return this._cachedHasShipTierRequirement;
  }
  get shipTierRequirement() {
    if (this._cachedShipTierRequirement === undefined) {
      if (this._value.hasShipTierRequirement) {
        this._cachedShipTierRequirement = this._value.shipTierRequirement;
      } else {
        this._cachedShipTierRequirement = this._parent ? this._parent.shipTierRequirement : this._value.shipTierRequirement;
      }
    }
    return this._cachedShipTierRequirement;
  }
  get selfUpgrades() {
    return this._value.upgrades;
  }
  get inherentUpgrades() {
    if (!this._inherentUpgrades) {
      this._inherentUpgrades = this._parent ? this._parent.upgrades : [];
    }
    return this._inherentUpgrades;
  }
  get upgrades() {
    if (!this._allUpgrades) {
      this._allUpgrades = this._parent ? this._parent.upgrades.concat(this.selfUpgrades) : this.selfUpgrades;
    }
    return this._allUpgrades;
  }
  get selfUnlockedAbilities() {
    return this._value.unlockedAbilities;
  }
  get inherentUnlockedAbilities() {
    if (!this._inherentUnlockedAbilities) {
      this._inherentUnlockedAbilities = this._parent ? this._parent.unlockedAbilities : [];
    }
    return this._inherentUnlockedAbilities;
  }
  get unlockedAbilities() {
    if (!this._allUnlockedAbilities) {
      this._allUnlockedAbilities = this._parent ? this._parent.unlockedAbilities.concat(this.selfUnlockedAbilities) : this.selfUnlockedAbilities;
    }
    return this._allUnlockedAbilities;
  }
  get selfUnlockedWeapons() {
    return this._value.unlockedWeapons;
  }
  get inherentUnlockedWeapons() {
    if (!this._inherentUnlockedWeapons) {
      this._inherentUnlockedWeapons = this._parent ? this._parent.unlockedWeapons : [];
    }
    return this._inherentUnlockedWeapons;
  }
  get unlockedWeapons() {
    if (!this._allUnlockedWeapons) {
      this._allUnlockedWeapons = this._parent ? this._parent.unlockedWeapons.concat(this.selfUnlockedWeapons) : this.selfUnlockedWeapons;
    }
    return this._allUnlockedWeapons;
  }
  get selfUnlockedBehaviors() {
    return this._value.unlockedBehaviors;
  }
  get inherentUnlockedBehaviors() {
    if (!this._inherentUnlockedBehaviors) {
      this._inherentUnlockedBehaviors = this._parent ? this._parent.unlockedBehaviors : [];
    }
    return this._inherentUnlockedBehaviors;
  }
  get unlockedBehaviors() {
    if (!this._allUnlockedBehaviors) {
      this._allUnlockedBehaviors = this._parent ? this._parent.unlockedBehaviors.concat(this.selfUnlockedBehaviors) : this.selfUnlockedBehaviors;
    }
    return this._allUnlockedBehaviors;
  }
  get selfCardBoosts() {
    if (!this._selfCardBoosts) {
      this._selfCardBoosts = [];
      for (let i of this._value.cardBoosts) {
        this._selfCardBoosts.push(new CardBoost.WithParent(i, null));
      }
    }
    return this._selfCardBoosts;
  }
  get inherentCardBoosts() {
    if (!this._inherentCardBoosts) {
      this._inherentCardBoosts = this._parent ? this._parent.cardBoosts : [];
    }
    return this._inherentCardBoosts;
  }
  get cardBoosts() {
    if (!this._allCardBoosts) {
      this._allCardBoosts = this._parent ? this._parent.cardBoosts.concat(this.selfCardBoosts) : this.selfCardBoosts;
    }
    return this._allCardBoosts;
  }
  get selfCardRequirements() {
    if (!this._selfCardRequirements) {
      this._selfCardRequirements = [];
      for (let i of this._value.cardRequirements) {
        this._selfCardRequirements.push(new ShipTalentCardRequirement.WithParent(i, null));
      }
    }
    return this._selfCardRequirements;
  }
  get inherentCardRequirements() {
    if (!this._inherentCardRequirements) {
      this._inherentCardRequirements = this._parent ? this._parent.cardRequirements : [];
    }
    return this._inherentCardRequirements;
  }
  get cardRequirements() {
    if (!this._allCardRequirements) {
      this._allCardRequirements = this._parent ? this._parent.cardRequirements.concat(this.selfCardRequirements) : this.selfCardRequirements;
    }
    return this._allCardRequirements;
  }
  get selfSubTalents() {
    return this._value.subTalents;
  }
  get inherentSubTalents() {
    if (!this._inherentSubTalents) {
      this._inherentSubTalents = this._parent ? this._parent.subTalents : [];
    }
    return this._inherentSubTalents;
  }
  get subTalents() {
    if (!this._allSubTalents) {
      this._allSubTalents = this._parent ? this._parent.subTalents.concat(this.selfSubTalents) : this.selfSubTalents;
    }
    return this._allSubTalents;
  }
  update(current, parent) {
    const result = new ShipTalentDefinition_WithParent(current, parent);
    if (this._selfCardBoosts) {
      if (this._value.cardBoosts === current.cardBoosts) {
        result._selfCardBoosts = this._selfCardBoosts;
      } else {
        result._selfCardBoosts = [];
        for (let i = 0; i < current.cardBoosts.length; i++) {
          const oldValue = this._value.cardBoosts[i];
          if (oldValue) {
            const oldCache = this._selfCardBoosts[i];
            if (oldValue === current.cardBoosts[i]) {
              result._selfCardBoosts[i] = oldCache;
            } else {
              result._selfCardBoosts[i] = oldCache.update(current.cardBoosts[i], null);
            }
          } else {
            result._selfCardBoosts[i] = new CardBoost.WithParent(current.cardBoosts[i], null);
          }
        }
      }
    }
    if (this._selfCardRequirements) {
      if (this._value.cardRequirements === current.cardRequirements) {
        result._selfCardRequirements = this._selfCardRequirements;
      } else {
        result._selfCardRequirements = [];
        for (let i = 0; i < current.cardRequirements.length; i++) {
          const oldValue = this._value.cardRequirements[i];
          if (oldValue) {
            const oldCache = this._selfCardRequirements[i];
            if (oldValue === current.cardRequirements[i]) {
              result._selfCardRequirements[i] = oldCache;
            } else {
              result._selfCardRequirements[i] = oldCache.update(current.cardRequirements[i], null);
            }
          } else {
            result._selfCardRequirements[i] = new ShipTalentCardRequirement.WithParent(current.cardRequirements[i], null);
          }
        }
      }
    }
    return result;
  }
}
ShipTalentDefinition_WithParent.default = new ShipTalentDefinition_WithParent(ShipTalentDefinition.default, null);
ShipTalentDefinition.WithParent = ShipTalentDefinition_WithParent;
class ShipTalentDefinition_Descriptor {
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 1,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get displayName() {
    if (!this._displayName) {
      this._displayName = {
        name: "displayName",
        Name: "DisplayName",
        number: 2,
        protoType: 9,
        protoName: "display_name",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayName;
  }
  get description() {
    if (!this._description) {
      this._description = {
        name: "description",
        Name: "Description",
        number: 3,
        protoType: 9,
        protoName: "description",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._description;
  }
  get description2() {
    if (!this._description2) {
      this._description2 = {
        name: "description2",
        Name: "Description2",
        number: 4,
        protoType: 9,
        protoName: "description_2",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._description2;
  }
  get icon() {
    if (!this._icon) {
      this._icon = {
        name: "icon",
        Name: "Icon",
        number: 6,
        protoType: 9,
        protoName: "icon",
        type: JsonToString,
        options: {
          valueDropdown: "SkillIcons",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._icon;
  }
  get shipTierRequirement() {
    if (!this._shipTierRequirement) {
      this._shipTierRequirement = {
        name: "shipTierRequirement",
        Name: "ShipTierRequirement",
        number: 7,
        protoType: 5,
        protoName: "ship_tier_requirement",
        type: JsonToInt32,
        options: {
          comments: "unlocked when card star reaches this number",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._shipTierRequirement;
  }
  get upgrades() {
    if (!this._upgrades) {
      this._upgrades = {
        name: "upgrades",
        Name: "Upgrades",
        number: 8,
        protoType: 9,
        protoName: "upgrades",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "SupportedDataUpgrades",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._upgrades;
  }
  get unlockedAbilities() {
    if (!this._unlockedAbilities) {
      this._unlockedAbilities = {
        name: "unlockedAbilities",
        Name: "UnlockedAbilities",
        number: 9,
        protoType: 9,
        protoName: "unlocked_abilities",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "abilities unlocked when the skill is bought",
          valueDropdown: "AbilityNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unlockedAbilities;
  }
  get unlockedWeapons() {
    if (!this._unlockedWeapons) {
      this._unlockedWeapons = {
        name: "unlockedWeapons",
        Name: "UnlockedWeapons",
        number: 10,
        protoType: 9,
        protoName: "unlocked_weapons",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "WeaponNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unlockedWeapons;
  }
  get unlockedBehaviors() {
    if (!this._unlockedBehaviors) {
      this._unlockedBehaviors = {
        name: "unlockedBehaviors",
        Name: "UnlockedBehaviors",
        number: 11,
        protoType: 9,
        protoName: "unlocked_behaviors",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "BehaviorNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unlockedBehaviors;
  }
  get cardBoosts() {
    if (!this._cardBoosts) {
      this._cardBoosts = {
        name: "cardBoosts",
        Name: "CardBoosts",
        number: 12,
        protoType: 11,
        protoName: "card_boosts",
        type: CardBoost,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardBoosts;
  }
  get cardRequirements() {
    if (!this._cardRequirements) {
      this._cardRequirements = {
        name: "cardRequirements",
        Name: "CardRequirements",
        number: 13,
        protoType: 11,
        protoName: "card_requirements",
        type: ShipTalentCardRequirement,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardRequirements;
  }
  get subTalents() {
    if (!this._subTalents) {
      this._subTalents = {
        name: "subTalents",
        Name: "SubTalents",
        number: 14,
        protoType: 9,
        protoName: "sub_talents",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._subTalents;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.name,
        this.displayName,
        this.description,
        this.description2,
        this.icon,
        this.shipTierRequirement,
        this.upgrades,
        this.unlockedAbilities,
        this.unlockedWeapons,
        this.unlockedBehaviors,
        this.cardBoosts,
        this.cardRequirements,
        this.subTalents,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayName",
        Name: "DummyOneofForDisplayName",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDescription",
        Name: "DummyOneofForDescription",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDescription2",
        Name: "DummyOneofForDescription2",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIcon",
        Name: "DummyOneofForIcon",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForShipTierRequirement",
        Name: "DummyOneofForShipTierRequirement",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
ShipTalentDefinition.descriptor = new ShipTalentDefinition_Descriptor();
export class ShipTierProgression {
  get descriptor() {
    return ShipTierProgression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasShipTier = false;
    this._shipTier = null;
    this._hasEquippedTalent = false;
    this._equippedTalent = null;
  }
  isEmpty() {
    if (this._hasShipTier) return false;
    if (this._hasEquippedTalent) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ShipTierProgression) {
      return value;
    }
    return ShipTierProgression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ShipTierProgression();
    if (json.shipTier != null) {
      result._hasShipTier = true;
      result._shipTier = JsonToInt32.fromJson(json.shipTier);
    }
    if (json.equippedTalent != null) {
      result._hasEquippedTalent = true;
      result._equippedTalent = JsonToString.fromJson(json.equippedTalent);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasShipTier) {
      result.shipTier = JsonToInt32.toJson(this._shipTier);
    }
    if (this._hasEquippedTalent) {
      result.equippedTalent = JsonToString.toJson(this._equippedTalent);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get shipTier() {
    return this._hasShipTier ? this._shipTier : JsonToInt32.default;
  }
  get hasShipTier() {
    return this._hasShipTier;
  }
  setShipTier(path, value) {
    return {type: 'SET', path: path.concat(['shipTier']), value};
  }
  deleteShipTier(path) {
    return {type: 'DELETE', path: path.concat(['shipTier'])};
  }
  /**
   * @returns {string}
   */
  get equippedTalent() {
    return this._hasEquippedTalent ? this._equippedTalent : JsonToString.default;
  }
  get hasEquippedTalent() {
    return this._hasEquippedTalent;
  }
  setEquippedTalent(path, value) {
    return {type: 'SET', path: path.concat(['equippedTalent']), value};
  }
  deleteEquippedTalent(path) {
    return {type: 'DELETE', path: path.concat(['equippedTalent'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "shipTier": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipTierProgression(this);
              copy._hasShipTier = true;
              copy._shipTier = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShipTier) {
                return this;
              }
              const copy = new ShipTierProgression(this);
              copy._hasShipTier = false;
              copy._shipTier = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "equippedTalent": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipTierProgression(this);
              copy._hasEquippedTalent = true;
              copy._equippedTalent = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEquippedTalent) {
                return this;
              }
              const copy = new ShipTierProgression(this);
              copy._hasEquippedTalent = false;
              copy._equippedTalent = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ShipTierProgression} other
   * @returns {ShipTierProgression}
   */
  merge(other) {
    const copy = new ShipTierProgression(this);
    if (other._hasShipTier) {
      copy._hasShipTier = true;
      copy._shipTier = other._shipTier;
    }
    if (other._hasEquippedTalent) {
      copy._hasEquippedTalent = true;
      copy._equippedTalent = other._equippedTalent;
    }
    return copy;
  }
}
ShipTierProgression.default = new ShipTierProgression();
class ShipTierProgression_Builder {
  constructor(value) {
    this._value = new ShipTierProgression(value);
  }
  build() {
    return new ShipTierProgression(this._value);
  }
  setShipTier(value) {
    this._value._hasShipTier = true;
    this._value._shipTier = value;
    return this;
  }
  deleteShipTier() {
    this._value._hasShipTier = false;
    this._value._shipTier = null;
    return this;
  }
  setEquippedTalent(value) {
    this._value._hasEquippedTalent = true;
    this._value._equippedTalent = value;
    return this;
  }
  deleteEquippedTalent() {
    this._value._hasEquippedTalent = false;
    this._value._equippedTalent = null;
    return this;
  }
}
ShipTierProgression.Builder = ShipTierProgression_Builder;
class ShipTierProgression_WithParent {
  /**
   * @param {ShipTierProgression} value
   * @param {ShipTierProgression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ShipTierProgression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasShipTier() {
    if (this._cachedHasShipTier === undefined) {
      if (this._value.hasShipTier) {
        this._cachedHasShipTier = true;
      } else {
        this._cachedHasShipTier = this._parent ? this._parent.hasShipTier : false;
      }
    }
    return this._cachedHasShipTier;
  }
  get shipTier() {
    if (this._cachedShipTier === undefined) {
      if (this._value.hasShipTier) {
        this._cachedShipTier = this._value.shipTier;
      } else {
        this._cachedShipTier = this._parent ? this._parent.shipTier : this._value.shipTier;
      }
    }
    return this._cachedShipTier;
  }
  get hasEquippedTalent() {
    if (this._cachedHasEquippedTalent === undefined) {
      if (this._value.hasEquippedTalent) {
        this._cachedHasEquippedTalent = true;
      } else {
        this._cachedHasEquippedTalent = this._parent ? this._parent.hasEquippedTalent : false;
      }
    }
    return this._cachedHasEquippedTalent;
  }
  get equippedTalent() {
    if (this._cachedEquippedTalent === undefined) {
      if (this._value.hasEquippedTalent) {
        this._cachedEquippedTalent = this._value.equippedTalent;
      } else {
        this._cachedEquippedTalent = this._parent ? this._parent.equippedTalent : this._value.equippedTalent;
      }
    }
    return this._cachedEquippedTalent;
  }
  update(current, parent) {
    const result = new ShipTierProgression_WithParent(current, parent);
    return result;
  }
}
ShipTierProgression_WithParent.default = new ShipTierProgression_WithParent(ShipTierProgression.default, null);
ShipTierProgression.WithParent = ShipTierProgression_WithParent;
class ShipTierProgression_Descriptor {
  get shipTier() {
    if (!this._shipTier) {
      this._shipTier = {
        name: "shipTier",
        Name: "ShipTier",
        number: 1,
        protoType: 5,
        protoName: "ship_tier",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._shipTier;
  }
  get equippedTalent() {
    if (!this._equippedTalent) {
      this._equippedTalent = {
        name: "equippedTalent",
        Name: "EquippedTalent",
        number: 2,
        protoType: 9,
        protoName: "equipped_talent",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._equippedTalent;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.shipTier,
        this.equippedTalent,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForShipTier",
        Name: "DummyOneofForShipTier",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEquippedTalent",
        Name: "DummyOneofForEquippedTalent",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
ShipTierProgression.descriptor = new ShipTierProgression_Descriptor();
export class ShipTalentConfiguration {
  get descriptor() {
    return ShipTalentConfiguration.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasName = false;
    this._name = null;
    this._goldTierProgression = [];
  }
  isEmpty() {
    if (this._hasName) return false;
    if (this._goldTierProgression.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ShipTalentConfiguration) {
      return value;
    }
    return ShipTalentConfiguration.fromJson(value);
  }
  static fromJson(json) {
    const result = new ShipTalentConfiguration();
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    result._goldTierProgression = JsonToList(json.goldTierProgression, ShipTierProgression);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._goldTierProgression.length > 0) {
      result.goldTierProgression = ArrayToJson(this._goldTierProgression, ShipTierProgression);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {ShipTierProgression[]}
   */
  get goldTierProgression() {
    return this._goldTierProgression;
  }
  addGoldTierProgression(path, value) {
    return {type: 'ADD', path: path.concat(['goldTierProgression']), value: value.toJson()};
  }
  setGoldTierProgression(path, value) {
    return {type: 'SET', path: path.concat(['goldTierProgression']), value: ArrayToJson(value, ShipTierProgression)};
  }
  setGoldTierProgressionByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['goldTierProgression', key]), value: value.toJson()};
  }
  deleteGoldTierProgression(path) {
    return {type: 'DELETE', path: path.concat(['goldTierProgression'])};
  }
  deleteGoldTierProgressionByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['goldTierProgression', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipTalentConfiguration(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new ShipTalentConfiguration(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "goldTierProgression": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipTalentConfiguration(this);
              copy._goldTierProgression = [];        for (let i of value) {
                copy._goldTierProgression.push(ShipTierProgression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ShipTalentConfiguration(this);
              copy._goldTierProgression = copy._goldTierProgression.concat([ShipTierProgression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._goldTierProgression.length === 0) {
                return this;
              }
              const copy = new ShipTalentConfiguration(this);
              copy._goldTierProgression = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._goldTierProgression.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ShipTalentConfiguration(this);
              copy._goldTierProgression = copy._goldTierProgression.slice();
              copy._goldTierProgression[path[1]] = ShipTierProgression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ShipTalentConfiguration(this);
              copy._goldTierProgression = copy._goldTierProgression.slice(0, path[1]).concat(copy._goldTierProgression.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._goldTierProgression.length) {
            return this;
          }
          const oldValue = this._goldTierProgression[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ShipTalentConfiguration(this);
          copy._goldTierProgression = copy._goldTierProgression.slice();
          copy._goldTierProgression[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ShipTalentConfiguration} other
   * @returns {ShipTalentConfiguration}
   */
  merge(other) {
    const copy = new ShipTalentConfiguration(this);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    copy._goldTierProgression = this._goldTierProgression.concat(other._goldTierProgression);
    return copy;
  }
}
ShipTalentConfiguration.default = new ShipTalentConfiguration();
class ShipTalentConfiguration_Builder {
  constructor(value) {
    this._value = new ShipTalentConfiguration(value);
  }
  build() {
    return new ShipTalentConfiguration(this._value);
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  addAllGoldTierProgression(values) {
    this._value._goldTierProgression = this._value._goldTierProgression.concat(values);
    return this;
  }
  addGoldTierProgression(value) {
    this._value._goldTierProgression = this._value._goldTierProgression.concat([value]);
    return this;
  }
  setGoldTierProgression(index, value) {
    this._value._goldTierProgression = this._value._goldTierProgression.concat();
    this._value._goldTierProgression[index] = value;
    return this;
  }
  clearGoldTierProgression() {
    this._value._goldTierProgression = [];
    return this;
  }
}
ShipTalentConfiguration.Builder = ShipTalentConfiguration_Builder;
class ShipTalentConfiguration_WithParent {
  /**
   * @param {ShipTalentConfiguration} value
   * @param {ShipTalentConfiguration_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ShipTalentConfiguration.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get selfGoldTierProgression() {
    if (!this._selfGoldTierProgression) {
      this._selfGoldTierProgression = [];
      for (let i of this._value.goldTierProgression) {
        this._selfGoldTierProgression.push(new ShipTierProgression.WithParent(i, null));
      }
    }
    return this._selfGoldTierProgression;
  }
  get inherentGoldTierProgression() {
    if (!this._inherentGoldTierProgression) {
      this._inherentGoldTierProgression = this._parent ? this._parent.goldTierProgression : [];
    }
    return this._inherentGoldTierProgression;
  }
  get goldTierProgression() {
    if (!this._allGoldTierProgression) {
      this._allGoldTierProgression = this._parent ? this._parent.goldTierProgression.concat(this.selfGoldTierProgression) : this.selfGoldTierProgression;
    }
    return this._allGoldTierProgression;
  }
  update(current, parent) {
    const result = new ShipTalentConfiguration_WithParent(current, parent);
    if (this._selfGoldTierProgression) {
      if (this._value.goldTierProgression === current.goldTierProgression) {
        result._selfGoldTierProgression = this._selfGoldTierProgression;
      } else {
        result._selfGoldTierProgression = [];
        for (let i = 0; i < current.goldTierProgression.length; i++) {
          const oldValue = this._value.goldTierProgression[i];
          if (oldValue) {
            const oldCache = this._selfGoldTierProgression[i];
            if (oldValue === current.goldTierProgression[i]) {
              result._selfGoldTierProgression[i] = oldCache;
            } else {
              result._selfGoldTierProgression[i] = oldCache.update(current.goldTierProgression[i], null);
            }
          } else {
            result._selfGoldTierProgression[i] = new ShipTierProgression.WithParent(current.goldTierProgression[i], null);
          }
        }
      }
    }
    return result;
  }
}
ShipTalentConfiguration_WithParent.default = new ShipTalentConfiguration_WithParent(ShipTalentConfiguration.default, null);
ShipTalentConfiguration.WithParent = ShipTalentConfiguration_WithParent;
class ShipTalentConfiguration_Descriptor {
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 1,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get goldTierProgression() {
    if (!this._goldTierProgression) {
      this._goldTierProgression = {
        name: "goldTierProgression",
        Name: "GoldTierProgression",
        number: 2,
        protoType: 11,
        protoName: "gold_tier_progression",
        type: ShipTierProgression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._goldTierProgression;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.name,
        this.goldTierProgression,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
ShipTalentConfiguration.descriptor = new ShipTalentConfiguration_Descriptor();
export class ShipUpgradeProgression {
  get descriptor() {
    return ShipUpgradeProgression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._goldTierProgression = [];
    this._silverTierProgression = [];
    this._shipTalentConfigurations = [];
  }
  isEmpty() {
    if (this._goldTierProgression.length > 0) return false;
    if (this._silverTierProgression.length > 0) return false;
    if (this._shipTalentConfigurations.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ShipUpgradeProgression) {
      return value;
    }
    return ShipUpgradeProgression.fromJson(value);
  }
  static fromJson(json) {
    const result = new ShipUpgradeProgression();
    result._goldTierProgression = JsonToList(json.goldTierProgression, ShipTierProgression);
    result._silverTierProgression = JsonToList(json.silverTierProgression, ShipTierProgression);
    result._shipTalentConfigurations = JsonToList(json.shipTalentConfigurations, ShipTalentConfiguration);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._goldTierProgression.length > 0) {
      result.goldTierProgression = ArrayToJson(this._goldTierProgression, ShipTierProgression);
    }
    if (this._silverTierProgression.length > 0) {
      result.silverTierProgression = ArrayToJson(this._silverTierProgression, ShipTierProgression);
    }
    if (this._shipTalentConfigurations.length > 0) {
      result.shipTalentConfigurations = ArrayToJson(this._shipTalentConfigurations, ShipTalentConfiguration);
    }
    return result;
  }
  /**
   * @returns {ShipTierProgression[]}
   */
  get goldTierProgression() {
    return this._goldTierProgression;
  }
  addGoldTierProgression(path, value) {
    return {type: 'ADD', path: path.concat(['goldTierProgression']), value: value.toJson()};
  }
  setGoldTierProgression(path, value) {
    return {type: 'SET', path: path.concat(['goldTierProgression']), value: ArrayToJson(value, ShipTierProgression)};
  }
  setGoldTierProgressionByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['goldTierProgression', key]), value: value.toJson()};
  }
  deleteGoldTierProgression(path) {
    return {type: 'DELETE', path: path.concat(['goldTierProgression'])};
  }
  deleteGoldTierProgressionByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['goldTierProgression', key])};
  }
  /**
   * @returns {ShipTierProgression[]}
   */
  get silverTierProgression() {
    return this._silverTierProgression;
  }
  addSilverTierProgression(path, value) {
    return {type: 'ADD', path: path.concat(['silverTierProgression']), value: value.toJson()};
  }
  setSilverTierProgression(path, value) {
    return {type: 'SET', path: path.concat(['silverTierProgression']), value: ArrayToJson(value, ShipTierProgression)};
  }
  setSilverTierProgressionByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['silverTierProgression', key]), value: value.toJson()};
  }
  deleteSilverTierProgression(path) {
    return {type: 'DELETE', path: path.concat(['silverTierProgression'])};
  }
  deleteSilverTierProgressionByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['silverTierProgression', key])};
  }
  /**
   * @returns {ShipTalentConfiguration[]}
   */
  get shipTalentConfigurations() {
    return this._shipTalentConfigurations;
  }
  addShipTalentConfigurations(path, value) {
    return {type: 'ADD', path: path.concat(['shipTalentConfigurations']), value: value.toJson()};
  }
  setShipTalentConfigurations(path, value) {
    return {type: 'SET', path: path.concat(['shipTalentConfigurations']), value: ArrayToJson(value, ShipTalentConfiguration)};
  }
  setShipTalentConfigurationsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['shipTalentConfigurations', key]), value: value.toJson()};
  }
  deleteShipTalentConfigurations(path) {
    return {type: 'DELETE', path: path.concat(['shipTalentConfigurations'])};
  }
  deleteShipTalentConfigurationsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['shipTalentConfigurations', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "goldTierProgression": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipUpgradeProgression(this);
              copy._goldTierProgression = [];        for (let i of value) {
                copy._goldTierProgression.push(ShipTierProgression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ShipUpgradeProgression(this);
              copy._goldTierProgression = copy._goldTierProgression.concat([ShipTierProgression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._goldTierProgression.length === 0) {
                return this;
              }
              const copy = new ShipUpgradeProgression(this);
              copy._goldTierProgression = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._goldTierProgression.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ShipUpgradeProgression(this);
              copy._goldTierProgression = copy._goldTierProgression.slice();
              copy._goldTierProgression[path[1]] = ShipTierProgression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ShipUpgradeProgression(this);
              copy._goldTierProgression = copy._goldTierProgression.slice(0, path[1]).concat(copy._goldTierProgression.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._goldTierProgression.length) {
            return this;
          }
          const oldValue = this._goldTierProgression[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ShipUpgradeProgression(this);
          copy._goldTierProgression = copy._goldTierProgression.slice();
          copy._goldTierProgression[key] = newValue;
          return copy;
        }
      }
      case "silverTierProgression": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipUpgradeProgression(this);
              copy._silverTierProgression = [];        for (let i of value) {
                copy._silverTierProgression.push(ShipTierProgression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ShipUpgradeProgression(this);
              copy._silverTierProgression = copy._silverTierProgression.concat([ShipTierProgression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._silverTierProgression.length === 0) {
                return this;
              }
              const copy = new ShipUpgradeProgression(this);
              copy._silverTierProgression = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._silverTierProgression.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ShipUpgradeProgression(this);
              copy._silverTierProgression = copy._silverTierProgression.slice();
              copy._silverTierProgression[path[1]] = ShipTierProgression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ShipUpgradeProgression(this);
              copy._silverTierProgression = copy._silverTierProgression.slice(0, path[1]).concat(copy._silverTierProgression.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._silverTierProgression.length) {
            return this;
          }
          const oldValue = this._silverTierProgression[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ShipUpgradeProgression(this);
          copy._silverTierProgression = copy._silverTierProgression.slice();
          copy._silverTierProgression[key] = newValue;
          return copy;
        }
      }
      case "shipTalentConfigurations": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ShipUpgradeProgression(this);
              copy._shipTalentConfigurations = [];        for (let i of value) {
                copy._shipTalentConfigurations.push(ShipTalentConfiguration.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ShipUpgradeProgression(this);
              copy._shipTalentConfigurations = copy._shipTalentConfigurations.concat([ShipTalentConfiguration.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._shipTalentConfigurations.length === 0) {
                return this;
              }
              const copy = new ShipUpgradeProgression(this);
              copy._shipTalentConfigurations = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._shipTalentConfigurations.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ShipUpgradeProgression(this);
              copy._shipTalentConfigurations = copy._shipTalentConfigurations.slice();
              copy._shipTalentConfigurations[path[1]] = ShipTalentConfiguration.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ShipUpgradeProgression(this);
              copy._shipTalentConfigurations = copy._shipTalentConfigurations.slice(0, path[1]).concat(copy._shipTalentConfigurations.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._shipTalentConfigurations.length) {
            return this;
          }
          const oldValue = this._shipTalentConfigurations[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ShipUpgradeProgression(this);
          copy._shipTalentConfigurations = copy._shipTalentConfigurations.slice();
          copy._shipTalentConfigurations[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ShipUpgradeProgression} other
   * @returns {ShipUpgradeProgression}
   */
  merge(other) {
    const copy = new ShipUpgradeProgression(this);
    copy._goldTierProgression = this._goldTierProgression.concat(other._goldTierProgression);
    copy._silverTierProgression = this._silverTierProgression.concat(other._silverTierProgression);
    copy._shipTalentConfigurations = this._shipTalentConfigurations.concat(other._shipTalentConfigurations);
    return copy;
  }
}
ShipUpgradeProgression.default = new ShipUpgradeProgression();
class ShipUpgradeProgression_Builder {
  constructor(value) {
    this._value = new ShipUpgradeProgression(value);
  }
  build() {
    return new ShipUpgradeProgression(this._value);
  }
  addAllGoldTierProgression(values) {
    this._value._goldTierProgression = this._value._goldTierProgression.concat(values);
    return this;
  }
  addGoldTierProgression(value) {
    this._value._goldTierProgression = this._value._goldTierProgression.concat([value]);
    return this;
  }
  setGoldTierProgression(index, value) {
    this._value._goldTierProgression = this._value._goldTierProgression.concat();
    this._value._goldTierProgression[index] = value;
    return this;
  }
  clearGoldTierProgression() {
    this._value._goldTierProgression = [];
    return this;
  }
  addAllSilverTierProgression(values) {
    this._value._silverTierProgression = this._value._silverTierProgression.concat(values);
    return this;
  }
  addSilverTierProgression(value) {
    this._value._silverTierProgression = this._value._silverTierProgression.concat([value]);
    return this;
  }
  setSilverTierProgression(index, value) {
    this._value._silverTierProgression = this._value._silverTierProgression.concat();
    this._value._silverTierProgression[index] = value;
    return this;
  }
  clearSilverTierProgression() {
    this._value._silverTierProgression = [];
    return this;
  }
  addAllShipTalentConfigurations(values) {
    this._value._shipTalentConfigurations = this._value._shipTalentConfigurations.concat(values);
    return this;
  }
  addShipTalentConfigurations(value) {
    this._value._shipTalentConfigurations = this._value._shipTalentConfigurations.concat([value]);
    return this;
  }
  setShipTalentConfigurations(index, value) {
    this._value._shipTalentConfigurations = this._value._shipTalentConfigurations.concat();
    this._value._shipTalentConfigurations[index] = value;
    return this;
  }
  clearShipTalentConfigurations() {
    this._value._shipTalentConfigurations = [];
    return this;
  }
}
ShipUpgradeProgression.Builder = ShipUpgradeProgression_Builder;
class ShipUpgradeProgression_WithParent {
  /**
   * @param {ShipUpgradeProgression} value
   * @param {ShipUpgradeProgression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ShipUpgradeProgression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfGoldTierProgression() {
    if (!this._selfGoldTierProgression) {
      this._selfGoldTierProgression = [];
      for (let i of this._value.goldTierProgression) {
        this._selfGoldTierProgression.push(new ShipTierProgression.WithParent(i, null));
      }
    }
    return this._selfGoldTierProgression;
  }
  get inherentGoldTierProgression() {
    if (!this._inherentGoldTierProgression) {
      this._inherentGoldTierProgression = this._parent ? this._parent.goldTierProgression : [];
    }
    return this._inherentGoldTierProgression;
  }
  get goldTierProgression() {
    if (!this._allGoldTierProgression) {
      this._allGoldTierProgression = this._parent ? this._parent.goldTierProgression.concat(this.selfGoldTierProgression) : this.selfGoldTierProgression;
    }
    return this._allGoldTierProgression;
  }
  get selfSilverTierProgression() {
    if (!this._selfSilverTierProgression) {
      this._selfSilverTierProgression = [];
      for (let i of this._value.silverTierProgression) {
        this._selfSilverTierProgression.push(new ShipTierProgression.WithParent(i, null));
      }
    }
    return this._selfSilverTierProgression;
  }
  get inherentSilverTierProgression() {
    if (!this._inherentSilverTierProgression) {
      this._inherentSilverTierProgression = this._parent ? this._parent.silverTierProgression : [];
    }
    return this._inherentSilverTierProgression;
  }
  get silverTierProgression() {
    if (!this._allSilverTierProgression) {
      this._allSilverTierProgression = this._parent ? this._parent.silverTierProgression.concat(this.selfSilverTierProgression) : this.selfSilverTierProgression;
    }
    return this._allSilverTierProgression;
  }
  get selfShipTalentConfigurations() {
    if (!this._selfShipTalentConfigurations) {
      this._selfShipTalentConfigurations = [];
      for (let i of this._value.shipTalentConfigurations) {
        this._selfShipTalentConfigurations.push(new ShipTalentConfiguration.WithParent(i, null));
      }
    }
    return this._selfShipTalentConfigurations;
  }
  get inherentShipTalentConfigurations() {
    if (!this._inherentShipTalentConfigurations) {
      this._inherentShipTalentConfigurations = this._parent ? this._parent.shipTalentConfigurations : [];
    }
    return this._inherentShipTalentConfigurations;
  }
  get shipTalentConfigurations() {
    if (!this._allShipTalentConfigurations) {
      this._allShipTalentConfigurations = this._parent ? this._parent.shipTalentConfigurations.concat(this.selfShipTalentConfigurations) : this.selfShipTalentConfigurations;
    }
    return this._allShipTalentConfigurations;
  }
  update(current, parent) {
    const result = new ShipUpgradeProgression_WithParent(current, parent);
    if (this._selfGoldTierProgression) {
      if (this._value.goldTierProgression === current.goldTierProgression) {
        result._selfGoldTierProgression = this._selfGoldTierProgression;
      } else {
        result._selfGoldTierProgression = [];
        for (let i = 0; i < current.goldTierProgression.length; i++) {
          const oldValue = this._value.goldTierProgression[i];
          if (oldValue) {
            const oldCache = this._selfGoldTierProgression[i];
            if (oldValue === current.goldTierProgression[i]) {
              result._selfGoldTierProgression[i] = oldCache;
            } else {
              result._selfGoldTierProgression[i] = oldCache.update(current.goldTierProgression[i], null);
            }
          } else {
            result._selfGoldTierProgression[i] = new ShipTierProgression.WithParent(current.goldTierProgression[i], null);
          }
        }
      }
    }
    if (this._selfSilverTierProgression) {
      if (this._value.silverTierProgression === current.silverTierProgression) {
        result._selfSilverTierProgression = this._selfSilverTierProgression;
      } else {
        result._selfSilverTierProgression = [];
        for (let i = 0; i < current.silverTierProgression.length; i++) {
          const oldValue = this._value.silverTierProgression[i];
          if (oldValue) {
            const oldCache = this._selfSilverTierProgression[i];
            if (oldValue === current.silverTierProgression[i]) {
              result._selfSilverTierProgression[i] = oldCache;
            } else {
              result._selfSilverTierProgression[i] = oldCache.update(current.silverTierProgression[i], null);
            }
          } else {
            result._selfSilverTierProgression[i] = new ShipTierProgression.WithParent(current.silverTierProgression[i], null);
          }
        }
      }
    }
    if (this._selfShipTalentConfigurations) {
      if (this._value.shipTalentConfigurations === current.shipTalentConfigurations) {
        result._selfShipTalentConfigurations = this._selfShipTalentConfigurations;
      } else {
        result._selfShipTalentConfigurations = [];
        for (let i = 0; i < current.shipTalentConfigurations.length; i++) {
          const oldValue = this._value.shipTalentConfigurations[i];
          if (oldValue) {
            const oldCache = this._selfShipTalentConfigurations[i];
            if (oldValue === current.shipTalentConfigurations[i]) {
              result._selfShipTalentConfigurations[i] = oldCache;
            } else {
              result._selfShipTalentConfigurations[i] = oldCache.update(current.shipTalentConfigurations[i], null);
            }
          } else {
            result._selfShipTalentConfigurations[i] = new ShipTalentConfiguration.WithParent(current.shipTalentConfigurations[i], null);
          }
        }
      }
    }
    return result;
  }
}
ShipUpgradeProgression_WithParent.default = new ShipUpgradeProgression_WithParent(ShipUpgradeProgression.default, null);
ShipUpgradeProgression.WithParent = ShipUpgradeProgression_WithParent;
class ShipUpgradeProgression_Descriptor {
  get goldTierProgression() {
    if (!this._goldTierProgression) {
      this._goldTierProgression = {
        name: "goldTierProgression",
        Name: "GoldTierProgression",
        number: 1,
        protoType: 11,
        protoName: "gold_tier_progression",
        type: ShipTierProgression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._goldTierProgression;
  }
  get silverTierProgression() {
    if (!this._silverTierProgression) {
      this._silverTierProgression = {
        name: "silverTierProgression",
        Name: "SilverTierProgression",
        number: 2,
        protoType: 11,
        protoName: "silver_tier_progression",
        type: ShipTierProgression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._silverTierProgression;
  }
  get shipTalentConfigurations() {
    if (!this._shipTalentConfigurations) {
      this._shipTalentConfigurations = {
        name: "shipTalentConfigurations",
        Name: "ShipTalentConfigurations",
        number: 3,
        protoType: 11,
        protoName: "ship_talent_configurations",
        type: ShipTalentConfiguration,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._shipTalentConfigurations;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.goldTierProgression,
        this.silverTierProgression,
        this.shipTalentConfigurations,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
ShipUpgradeProgression.descriptor = new ShipUpgradeProgression_Descriptor();
